<template>
  <div>
    <div class="digital">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="team">
        <div class="module">
          <div class="title">四大核心技术支撑</div>
          <div class="list">
            <div>
              <div class="title">模型搭建</div>
              <div class="p">
                <p>
                  基于三维倾斜摄影技术、激光点云技术、人工测绘技术等空间数据采集技术，构建实景空间三维模型。
                </p>
                <p>适用于从宏观到微观，从城市到建筑及设备的全场景搭建。</p>
                <p>符合GIS、BIM等各专业技术标准。</p>
              </div>
            </div>
            <div>
              <div class="title">三维可视化平台</div>
              <div class="p">
                <p>
                  创新的轻量化设计理念和开发架构，解决了从宏观到微观海量GIS+BIM三维模型数据的加载和渲染效率难题，实现了空间数据的渐进加载和极速渲染功能，提供了良好的用户体验。
                </p>
              </div>
              <router-link tag="div" class="button" to="/product"></router-link>
              <!-- <div class="button"></div> -->
            </div>
            <div>
              <div class="title">数据物联</div>
              <div class="p">
                <p>时空数据、物联网数据、业务数据的集成整合。</p>
                <p>
                  各类物联数据接口和协议的兼容。海量实时大数据的存储及分析管理技术。
                </p>
                <p>搭建物联数据网关和中台，为数字孪生平台提供数据服务支撑。</p>
              </div>
            </div>
            <div>
              <div class="title">人机交互</div>
              <div class="p">
                <p>
                  通过计算机输入、输出设备，以有效的方式实现人与计算机对话的技术。
                </p>
                <p>
                  虚拟与现实的空间切换，体现在VR体验上面，让用户拥有沉浸式体验。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="application">
        <div class="module">
          <div class="title">广泛应用各种行业场景</div>
          <div class="list">
            <div>
              <div class="title">场景3D全景可视化</div>
              <div class="content">
                <span>模拟仿真</span>
                <p>
                  减少实物实验次数<br />缩短产品设计周期<br />提高可行性和成功率<br />
                  降低试制和测试成本<br />减少危害和失误
                </p>
              </div>
            </div>
            <div>
              <div class="title">智慧城市/园区应用监测</div>
              <div class="content">
                <span>监测</span>
                <p>识别误差<br />定位故障<br />信息可视化<br />保障生命安全</p>
              </div>
            </div>
            <div>
              <div class="title">能耗及能源管理统计</div>
              <div class="content">
                <span>评估</span>
                <p>
                  提前预测指导决策<br />实时统计能源损耗<br />高效管理平台数据
                </p>
              </div>
            </div>
            <div>
              <div class="title">可视化运营监控</div>
              <div class="content">
                <span>控制</span>
                <p>
                  提高操作精度<br />适应环境变化<br />提高生产灵活度<br />实时响应扰动<br />
                  可视化运营监控
                </p>
              </div>
            </div>
            <div>
              <div class="title">综合分析优化</div>
              <div class="content">
                <span>优化</span>
                <p>
                  改变产品开发<br />加强安防管理<br />提高系统效率<br />节约资源<br />提升用户体验
                </p>
              </div>
            </div>
            <div>
              <div class="title">动画展示</div>
              <div class="content">
                <span>预测</span>
                <p>
                  减少宕机时间<br />避免灾害性破坏<br />提高产品质量<br />验证产品适应性
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="digital_list">
        <div class="title">相关案例</div>
        <div class="module">
          <div
            v-bind:title="'聚焦关键要素|打造智慧园区综合运营决策平台解决方案'"
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/501.html'
              )
            "
          >
            <div class="title">智慧园区/楼宇GIS+BIM+IOT运维平台</div>
          </div>
          <div
            v-bind:title="
              '基于臻图ZTMAP GIS核心技术，建设国内新型智慧城市解决方案'
            "
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/451.html'
              )
            "
          >
            <div class="title">城市大脑GIS+BIM可视化大屏</div>
          </div>
          <div
            v-bind:title="
              '上海臻图信息将以数字孪生技术开发，赋能智慧港口照明自动化系统新解决方案'
            "
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/471.html'
              )
            "
          >
            <div class="title">智慧港口数字孪生照明管理系统</div>
          </div>
          <div
            v-bind:title="
              '绿色双碳目标发展：ZTMap三维融合渲染平台打造数字孪生智慧电力运维保障系统'
            "
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/494.html'
              )
            "
          >
            <div class="title">数字孪生电力运维保障平台</div>
          </div>
          <div
            v-bind:title="'数字孪生智慧水务管理建设方案'"
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/500.html'
              )
            "
          >
            <div class="title">数字孪生智慧水务管理平台</div>
          </div>
          <div
            v-bind:title="'基于臻图ZTMAP 3DGIS平台打造线上线下融合的智慧展览中心'"
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/448.html'
              )
            "
          >
            <div class="title">智慧展览馆三维导览平台</div>
          </div>
          <div
            v-bind:title="'数字孪生三维可视化平台在城市大脑综合治理中的作用'"
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/446.html'
              )
            "
          >
            <div class="title">城市综合治理三维GIS平台</div>
          </div>
          <div
            v-bind:title="'探索“智慧社区”发展，打造一体化实用场景新建设'"
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/502.html'
              )
            "
          >
            <div class="title">智慧社区数字孪生可视化</div>
          </div>
          <div
            v-bind:title="
              '臻图信息基于GIS+BIM技术助力城市地下综合管廊绿色建设发展'
            "
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/518.html'
              )
            "
          >
            <div class="title">GIS+BIM地下综合管廊</div>
          </div>
          <div
            v-bind:title="
              '智慧旅游景区运营新模式，为旅游行业解决了哪些痛点？是怎么布局建设的？'
            "
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/470.html'
              )
            "
          >
            <div class="title">数字孪生旅游景区运营服务平台</div>
          </div>
          <div
            v-bind:title="'基于ZTMap助力传统道路交通管理向“智慧”发展转型升级'"
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/497.html'
              )
            "
          >
            <div class="title">数字孪生高速公路智慧服务区</div>
          </div>
          <div
            v-bind:title="
              'http://www.ztmapinfo.com/blog/index.php/article/460.html'
            "
            @click="
              handlehref(
                'http://www.ztmapinfo.com/blog/index.php/article/460.html'
              )
            "
          >
            <div class="title">数字孪智慧小区安防治理平台</div>
          </div>
        </div>
      </div>
      <div class="new_list">
        <div class="title">
          <div>经典解决方案</div>
        </div>
        <div class="module">
          <div
            class="item"
            v-for="(data, index) in newsItem"
            :key="index"
            @click="handlehref(data.url)"
          >
            <div class="title-wrapper">{{ data.title }}</div>
            <div class="content-wrapper">
              <div class="img-wrapper">
                <img :src="data.img" alt="" />
              </div>
              <div class="text-wrapper">
                <div>{{ data.desc }}</div>
                <div class="date-wrapper">
                  <div>
                    <div class="icon"></div>
                    {{ data.date }}
                  </div>
                  <div style="color: #338ecf">查看更多</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <img src="../assets/images/digital/地下综合管廊三维可视化系统.gif" alt=""> -->
    </div>
    <div class="mobile-digital">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="main">
        <div class="part1">
          <div class="part1-title">四大核心技术支撑</div>
          <div class="part1-content">
            <div class="item">
              <img src="../assets/images/digital/1.png" alt="">
              <div class="title1">模型搭建</div>
              <div class="p">
                <p>
                  基于三维倾斜摄影技术、激光点云技术、人工测绘技术等空间数据采集技术，构建实景空间三维模型。
                </p>
                <p>适用于从宏观到微观，从城市到建筑及设备的全场景搭建。</p>
                <p>符合GIS、BIM等各专业技术标准。</p>
              </div>
            </div>
            <div class="item">
              <img src="../assets/images/digital/2.png" alt="">
              <div class="title1">三维可视化平台</div>
              <div class="p">
                <p>
                  创新的轻量化设计理念和开发架构，解决了从宏观到微观海量GIS+BIM三维模型数据的加载和渲染效率难题，实现了空间数据的渐进加载和极速渲染功能，提供了良好的用户体验。
                </p>
              </div>
              <router-link tag="div" class="button" to="/product"></router-link>
            </div>
            <div class="item">
              <img src="../assets/images/digital/3.png" alt="">
              <div class="title1">数据物联</div>
              <div class="p">
                <p>时空数据、物联网数据、业务数据的集成整合。</p>
                <p>
                  各类物联数据接口和协议的兼容。海量实时大数据的存储及分析管理技术。
                </p>
                <p>搭建物联数据网关和中台，为数字孪生平台提供数据服务支撑。</p>
              </div>
            </div>
            <div class="item">
              <img src="../assets/images/digital/4.png" alt="">
              <div class="title1">人机交互</div>
              <div class="p">
                <p>
                  通过计算机输入、输出设备，以有效的方式实现人与计算机对话的技术。
                </p>
                <p>
                  虚拟与现实的空间切换，体现在VR体验上面，让用户拥有沉浸式体验。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="part2">
          <div class="part2-title">广泛应用各种行业场景</div>
          <div class="part2-content">
            <div>
              <div>场景3D全景可视化</div>
            </div>
            <div>
              <div>智慧城市/园区应用监测</div>
            </div>
            <div>
              <div>能耗及能源管理统计</div>
            </div>
            <div>
              <div>可视化运营监控</div>
            </div>
            <div>
              <div>综合分析优化</div>
            </div>
            <div>
              <div>动画展示</div>
            </div>
          </div>
        </div>
        <div class="part3">
          <div class="part3-title">相关案例</div>
          <div class="list">
            <div v-bind:title="'聚焦关键要素|打造智慧园区综合运营决策平台解决方案'"
              @click="
                handlehref(
                  'http://www.ztmapinfo.com/blog/index.php/article/501.html'
                )
             "
            >
              <div class="title">智慧园区/楼宇</br>GIS+BIM+IOT运维平台</div>
            </div>
            <div
              v-bind:title="
                '基于臻图ZTMAP GIS核心技术，建设国内新型智慧城市解决方案'
              "
              @click="
                handlehref(
                  'http://www.ztmapinfo.com/blog/index.php/article/451.html'
                )
              "
            >
              <div class="title">城市大脑GIS+BIM</br>可视化大屏</div>
            </div>
            <div
              v-bind:title="
                '上海臻图信息将以数字孪生技术开发，赋能智慧港口照明自动化系统新解决方案'
              "
              @click="
                handlehref(
                  'http://www.ztmapinfo.com/blog/index.php/article/471.html'
                )
              "
            >
              <div class="title">智慧港口数字孪生</br>照明管理系统</div>
            </div>
            <div
              v-bind:title="
                '绿色双碳目标发展：ZTMap三维融合渲染平台打造数字孪生智慧电力运维保障系统'
              "
              @click="
                handlehref(
                  'http://www.ztmapinfo.com/blog/index.php/article/494.html'
                )
              "
            >
              <div class="title">数字孪生电力</br>运维保障平台</div>
            </div>
            <div
              v-bind:title="'数字孪生智慧水务管理建设方案'"
              @click="
                handlehref(
                  'http://www.ztmapinfo.com/blog/index.php/article/500.html'
                )
              "
            >
              <div class="title">数字孪生智慧水务</br>管理平台</div>
            </div>
            <div
              v-bind:title="'基于臻图ZTMAP 3DGIS平台打造线上线下融合的智慧展览中心'"
              @click="
                handlehref(
                  'http://www.ztmapinfo.com/blog/index.php/article/448.html'
                )
              "
            >
              <div class="title">智慧展览馆</br>三维导览平台</div>
            </div>
            <template v-if="page>=2">
              <div
                v-bind:title="'数字孪生三维可视化平台在城市大脑综合治理中的作用'"
                @click="
                  handlehref(
                    'http://www.ztmapinfo.com/blog/index.php/article/446.html'
                  )
                "
              >
                <div class="title">城市综合治理</br>三维GIS平台</div>
              </div>
              <div
                v-bind:title="'探索“智慧社区”发展，打造一体化实用场景新建设'"
                @click="
                  handlehref(
                    'http://www.ztmapinfo.com/blog/index.php/article/502.html'
                  )
                "
              >
                <div class="title">智慧社区</br>数字孪生可视化</div>
              </div>
              <div
                v-bind:title="
                  '臻图信息基于GIS+BIM技术助力城市地下综合管廊绿色建设发展'
                "
                @click="
                  handlehref(
                    'http://www.ztmapinfo.com/blog/index.php/article/518.html'
                  )
                "
              >
                <div class="title">GIS+BIM</br>地下综合管廊</div>
              </div>
              <div
                v-bind:title="
                  '智慧旅游景区运营新模式，为旅游行业解决了哪些痛点？是怎么布局建设的？'
                "
                @click="
                  handlehref(
                    'http://www.ztmapinfo.com/blog/index.php/article/470.html'
                  )
                "
              >
                <div class="title">数字孪生旅游景区</br>运营服务平台</div>
              </div>
              <div
                v-bind:title="'基于ZTMap助力传统道路交通管理向“智慧”发展转型升级'"
                @click="
                  handlehref(
                    'http://www.ztmapinfo.com/blog/index.php/article/497.html'
                  )
                "
              >
                <div class="title">数字孪生高速公路</br>智慧服务区</div>
              </div>
              <div
                v-bind:title="
                  'http://www.ztmapinfo.com/blog/index.php/article/460.html'
                "
                @click="
                  handlehref(
                    'http://www.ztmapinfo.com/blog/index.php/article/460.html'
                  )
                "
              >
                <div class="title">数字孪智慧小区</br>安防治理平台</div>
              </div>
            </template>
          </div>
          <div class="more" v-if="page!=2" @click="page=page+1">
            <p>查看更多</p>
            <div>
              <i class="el-icon-arrow-down"></i>
              <i class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div class="part4">
          <div class="part4-title">经典解决方案</div>
          <div class="list">
            <div class="item"
              v-for="(data, index) in newsItem"
              :key="index"
              @click="handlehref(data.url)"
            >
              <div class="image"><img :src="data.img" alt="" /></div>
              <div class="item-content">
                <p>{{ data.title }}</p>
                <div class="item-span">{{ data.desc }}</div>
                <div class="item-bottom">
                  <span>{{ data.date }}</span>
                  <div>
                    <p>了解更多</p>
                    <i class="el-icon-d-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Digital",
  metaInfo: {
    title: "数字孪生可视化平台-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "数字孪生，三维可视化"
      },
      {
        name: "description",
        content:
          "提供ZTMapGIS、ZTMap3D、ZTMapVR、ZTMapInidoor系列三维可视化平台开发服务,包括开发API、接口文档、开发示例、DEMO演示等。"
      }
    ]
  },
  data() {
    return {
      page: 1,
      bannerData: {
        title: "数字孪生",
        p:
          "让事物更加透明，让管理更加智能。数字孪生是指针对物理世界中的物体，通过数字化的手段来构建一个数字世界中一模一样的的实体，并整合数据进行可视化发布，藉此来实现对物理实体的了解、分析和优化。<br/><br/>本质：数据+模型+可视化平台"
      },
      newsItem: [
        // {
        //   title:
        //     '数字孪生技术下的智慧医院再添新功能，室内地图导航让你“医”路畅通',
        //   desc:
        //     '如今，我国已经步入了“十四五”建设中，随着互联网业务的细分，医院和医疗的大数据建设也在逐渐向智慧化方向完善。但是医院建筑作为公共建筑最复杂结构之一，它拥有规模大、功能复杂等特点。面向医护人员、患者就诊、医院管理、追踪调查、监护查询等一系列基础医疗服务问题开始引起医院和人们的重视...',
        //   date: '2022-02-28',
        //   img: require('@/assets/images/digital/news/73.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/468.html'
        // },
        // {
        //   title:
        //     '关于数字孪生技术赋能协同一体化智慧公交建设，你想知道的解决方案都在这里',
        //   desc:
        //     '公交车是城市文明的流动窗口，反映着一座城市的文明程度和发展进程，而智慧公交是智慧城市必不可少的组成部分之一，随着信息技术的应用于发展，公交行业也将抓住数字化转型战略机遇，及时响应市场的需求，打造资源共享、创新驱动的智慧公交。 整体智慧公交数字孪生三维可视化平台，以客流车流调动信息为基础，考虑到了路况、活动、乘客等因素，实现了行车监控、车载安全设备、远程指挥管理等功能...',
        //   date: '2022-02-28',
        //   img: require('@/assets/images/digital/news/74.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/467.html'
        // },
        // {
        //   title: '日渐精细化的室内导航定位，蕴含着多大的商业价值你了解吗？',
        //   desc:
        //     '本项目针对各大商场室内地图导航，将充分利用最新的物联网数据可视化、云计算等，基于臻图信息ZTMap3D平台，结合GIS地理信息定位、VR实景三维可视化及商场基站，构建的商场实景室内导航定位“兜逛VR”，实现了商场内外部地图导航带来的潜在用户的人流量，通过商场内部信息整合让相关管理人员清晰直观的掌握实时运营中的有效信息，实现透明化与可视化的管理。真正实现一个立体式、可视化的新一代实时保障运维平台，充分满足端到端数据架构的展现需求...',
        //   date: '2022-02-28',
        //   img: require('@/assets/images/digital/news/75.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/459.html'
        // },
        // {
        //   title: '启动城市级智慧停车系统，让每一次出行都更加顺畅',
        //   desc:
        //     '上海臻图就解决智慧停车这一问题，提供全场景一站式城市级智慧停车解决方案，包括可视化监控智慧停车场解决方案、多样化停车场车位引导解决方案、城市停车诱导解决方案，构成了一套各有针对性的完整的解决方案体系。为城市管理者、停车场运营机构提供城市级智慧停车平台服务，实现停车服务的全场实景覆盖...',
        //   date: '2022-02-28',
        //   img: require('@/assets/images/digital/news/76.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/457.html'
        // },
        // {
        //   title:
        //     '凭借ZTMAPGIS开发系统，打造智慧林业巡护“一块屏”，全面加强森林资源保护新时代',
        //   desc:
        //     '随着经济迅速的增长，很多地方的森林资源正在遭受着不同程度的破坏，一方面来自于天灾，例如病虫害、恶劣天气、火灾等造成的巨大损失；另一方面就是人为的破坏，最主要的就是一些不法分子为了眼前利益对局部的乱砍、乱伐导致发森林资源遭到破坏。所以政府为了扩大林区面积，每年都会投入大量的人力、物力、财力用于植树造林...',
        //   date: '2022-02-28',
        //   img: require('@/assets/images/digital/news/77.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/458.html'
        // },
        // {
        //   title: '“疫情”防控时期大势所趋，智慧社区尽显“智慧”迎来新的发展热潮',
        //   desc:
        //     '上海臻图信息技术将本着以社区为核心，以人为本、规划统筹、创新引领、标准体系建立、多维可视化的原则，以数据融合展现可视化为基础，依托二三维GIS地理信息技术、VR全景技术，做到城市网格之间衔接无缝隙，聚焦社区服务和社区治理区域无缝隙，推进智慧社区一体化建设...',
        //   date: '2022-02-28',
        //   img: require('@/assets/images/digital/news/78.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/460.html'
        // },
        // {
        //   title:
        //     '基于【GIS地理信息+实景三维】在一体化地质灾害监测预警平台中的核心应用',
        //   desc:
        //     '地质灾害防治工作与人民群众生命财产安全直接相关，在“十三五”期间基于物联网、人工智能、网络感知、数字孪生等科学技术力量，逐渐完善提升地质灾害调查评价、监测分析、综合治理、应急预警防范四大工程治理体系，全面提升地质灾害预警防御能力，加强防灾减灾体系建设...',
        //   date: '2022-06-08',
        //   img: require('@/assets/images/digital/news/79.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/477.html'
        // },
        // {
        //   title:
        //     '物流行业：高端制造再掀热潮，绿色环保智慧仓储物流产业将迎来黄金发展新时段',
        //   desc:
        //     '面对日益增长的商品交付量，爆仓已成了现在仓储物流的最大困扰之一，传统的仓储管理和运作方式已无法满足现在的需求了，随着新基建和数字化技术的成熟，不得不重新规划仓储物流管理行业进行智慧化+数字化升级转型，同时搭配着ZTmap的三维可视化方案，让整个仓储物流全局运作“尽收眼底”，成为智慧城市建设...',
        //   date: '2022-06-08',
        //   img: require('@/assets/images/digital/news/80.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/472.html'
        // },
        // {
        //   title:
        //     '开创绿色智慧能源生态发展新局面，为打破传统理念提供可行解决方案',
        //   desc:
        //     '云计算、人工智能、大数据、5G、数字孪生等新兴热点技术的行业应用上，为构建智慧能源生态系统，打破能源行业存在的体制、技术、市场上的壁垒，加快智慧能源系统的数字化转型，实现智慧能源系统全要素的数字化和虚拟化，全状态的实时化和可视化以及后续运维管理中的协同化和智能化，建设互联互通、开放透明、互动共享的智慧能源管控平台...',
        //   date: '2022-06-08',
        //   img: require('@/assets/images/digital/news/81.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/476.html'
        // },
        // {
        //   title:
        //     '数字孪生技术搭建的智慧楼宇安防综合管控系统，在智慧城市发展中有何亮点？',
        //   desc:
        //     '由于近两年疫情对世界运转的各方面问题的影响，新兴技术的应用、科技的力量给我们的生活带来了诸多的便利，并随着各企业之间的复工复产，智慧概念的提出让建筑、楼宇、园区、土地规划、设备管理的建设也逐渐开始向科技技术靠拢。 楼宇作为城市的基石，与人的生活工作等息息相关，伴随着物联网、5G、区块链、人工智能、数字孪生、3DGIS...',
        //   date: '2022-06-08',
        //   img: require('@/assets/images/digital/news/82.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/475.html'
        // },
        // {
        //   title:
        //     '智慧旅游景区运营新模式，为旅游行业解决了哪些痛点？是怎么布局建设的？',
        //   desc:
        //     '面对旅游景区综合管理存在问题，跟紧“十四五”规划和2035年远景目标纲要提出，将以网络化、数字化、智能化为特殊手段深入发展“智慧景区、智慧旅游”的新概念建设，提高旅游行业高质量发展新动能、推动当地第三产业经济水平和社会形象。 智慧景区三维可视化管控平台的建设让旅游管理可以更精准的实时掌握景区整体情况，包括旅游...',
        //   date: '2022-06-08',
        //   img: require('@/assets/images/digital/news/83.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/470.html'
        // },
        // {
        //   title:
        //     '什么是智慧消防？数字孪生技术打造的“智慧消防”系统管控云平台了解一下',
        //   desc:
        //     '“消防”作为预防和解决人们在生活、工作、学习过程中遇到的人为与自然、偶然灾害的总称，随着我国提出的新基建、5G、产业升级、数字孪生、智慧城市、智慧社区、智慧园区等新概念的规划与实行，使得智慧消防也越来越得到政府及相关企业部门的重视，在面对灾害时防控能力的进一步提升，智慧消防也成为了消防工作中不可或缺的一股力量...',
        //   date: '2022-06-08',
        //   img: require('@/assets/images/digital/news/84.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/474.html'
        // },
        // {
        //   title: '闭环式数字孪生智慧交通管理系统平台应用及分析',
        //   desc:
        //     '随着数字孪生的发展，数字孪生不再仅仅是一种技术，更是新的发展模式、新的发展动力，满足数字交通时代下，交通行业发展的新目标和新需求。数字孪生技术动态实时感知现实世界，打通现实世界与虚拟世界屏障，未来市场空间充满想象。将会在智慧交通领域发挥重要作用，为交通参与者带来更佳的服务...',
        //   date: '2022-06-22',
        //   img: require('@/assets/images/digital/news/85.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/478.html'
        // },
        // {
        //   title: '探索数字孪生技术在智慧工厂安全管理系统中实现哪些应用？',
        //   desc:
        //     '顺应国家制造业和工业互联网发展趋势，在数字化工厂的基础上，面对越来越复杂的产品需求。工厂在单元设备级一步步走向智能化，最终目的就是要往系统智能化发展，变成一个智能工厂，使用数字孪生技术的综合解决方案来进行产品生产、装备运维、弹性物流等流程智慧化管理及智能化应用...',
        //   date: '2022-06-22',
        //   img: require('@/assets/images/digital/news/86.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/479.html'
        // },
        // {
        //   title: '什么是数字孪生？一文概括，通俗易懂的解读数字孪生关键技术',
        //   desc:
        //     '通俗地可以理解为：以数字化的方式建立物理实体的虚拟模型，物理世界数字化，借助历史数据、实时数据和算法模型，实现对物理实体的分析预测和改善优化，具有实时性和闭环性。数字孪生将割裂的虚拟世界与现实世界融合，是前沿科技下一个代际的发展主题...',
        //   date: '2022-06-22',
        //   img: require('@/assets/images/digital/news/87.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/480.html'
        // },
        // {
        //   title: '数字孪生技术赋能智慧环保三维可视化系统平台应用及发展',
        //   desc:
        //     '步入新时代，使用智能、环保的方法来改善城市环境治理是解决城市环境问题的新趋势。智能环境保护将协调和一致性的概念与以数字孪生技术、物联网平台和“互联网+”技术为代表的智能手段结合在一起，从而改变了基于人工的城市环境治理模式。在讨论智能环保的概念和我国城市智能环保的发展现状的基础上，提出了一系列解决方案...',
        //   date: '2022-06-22',
        //   img: require('@/assets/images/digital/news/88.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/482.html'
        // },
        // {
        //   title: '探究：数字孪生是如何赋能智慧能源信息化领域系统发展的？',
        //   desc:
        //     '全球能源行业顺应数字化时代不断发展，我国电力体制改革深入推进，在这一背景下加快能源转型已成为行业共识。但能源行业存在着体制、技术与市场壁垒，使得能源转型面临挑战。国家能源局提出智慧能源战略，建设互联互通、透明开放、互惠共享的能源共享平台，以期解决能源行业普遍存在的壁垒问题...',
        //   date: '2022-06-22',
        //   img: require('@/assets/images/digital/news/89.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/481.html'
        // },
        // {
        //   title: '基于数字孪生技术浅谈智慧园区的构建及其发展',
        //   desc:
        //     '“智慧园区是建立在数字化园区基础上的智能化园区，是智慧城市的缩影和体现。如今，智慧园区建设已经成为园区管理机构破解可持续发展难题、加速经济转型升级、提升园区吸引力的重要方式。本文主要根据现阶段智慧园区发展的趋势，提出智慧园区的设计思路以及现阶段国内智慧园区发展存在的痛点和解决对策...',
        //   date: '2022-06-22',
        //   img: require('@/assets/images/digital/news/90.png'),
        //   url: 'http://www.ztmapinfo.com/blog/index.php/article/483.html'
        // },
        {
          title: "数字孪生下的智慧园区信息化建设解决方案",
          desc:
            "随着互联网信息技术的不断发展和进步， 智慧 园区应用智能物联网的概念现在被广泛提及。 智慧 园区可以实现园区内多个系统之间的信息共享，打破园区内传统封闭系统的信息孤岛。从信息应用系统、平台层、通信网络、公共管理服务平台等方面，构建完善的智能园区信息化建设解决方案，实现园区智能化、...",
          date: "2022-07-13",
          img: require("@/assets/images/digital/news/91.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/490.html"
        },
        {
          title: "3DGIS+数字孪生技术打造智慧工地监控系统分析",
          desc:
            "在工程建设现场，工地的管理内容比较多，为了加强管理的效果，可应用智慧化工地监控系统来实现对工地的全面管理。通过对智慧工地的涵义的阐述，分析智慧化工地监控系统的应用意义及智能化工地中的技术应用，提出加强...",
          date: "2022-07-13",
          img: require("@/assets/images/digital/news/92.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/489.html"
        },
        {
          title: "基于(ztmap)BIM的数字孪生建造智慧机房管理后台展示系统",
          desc:
            "随着现代化的经济发展，社会当中逐渐普及了数字化智慧城市网络系统，人们对于相关数据业务提出了更高的建设要求，为了促使城市整体数据网络随着时代的发展而转变，成为更加智能化的数据群体，必须建立更新式、立体化的智慧机房管理系统，基于BIM三维模型运用数字孪生技术，实现数据交互可视化...",
          date: "2022-07-13",
          img: require("@/assets/images/digital/news/93.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/487.html"
        },
        {
          title: "水利工程数字孪生技术研究与探索 ",
          desc:
            "数字孪生以各领域日益庞大的数据为基本要素，借助发展迅速的建模仿真、人工智能、虚拟现实等先进技术，构建物理实体在虚拟空间中的数字孪生体，实现对物理实体的数字化管控与优化，开拓了企业数字化转型的可行思路。立足新发展阶段，初步分析了应用数字孪生技术建设智慧水利的技术路线和工作思路。结合工业工程的数字孪生技术...",
          date: "2022-07-13",
          img: require("@/assets/images/digital/news/94.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/486.html"
        },
        {
          title: "基于BIM+数字孪生技术在建筑工程项目中搭建绿色智慧管理系统",
          desc:
            "近几十年来，人类活动的急速增长，对自然资源的消耗和环境的影响越来越明显，所有人类活动中，建筑业的发展对自然资源和环境的影响尤其明显。于是，绿色施工、智慧环保、绿色建造的理念逐步深入人心，从设计到施工再到运营，人们都在开发和应用相关的技术，来减少建筑活动对资源和环境的不利影响...",
          date: "2022-07-13",
          img: require("@/assets/images/digital/news/95.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/485.html"
        },
        {
          title: "基于数字孪生的变电站三维全息研判智慧联动研究",
          desc:
            "“随着经济社会快速发展提升了人们生活质量和水平，加大了人们对电量的需求和要求，科学技术发展也促进了电网中应用了较多先进的技术，对实现变电站的智能化发挥着重要作用，而在这一过程中变电站中的智能操作技术更是得到了普遍应用。基于数字孪生的变电站三维全息研判智慧联动，在变电站的运行过程中...",
          date: "2022-07-13",
          img: require("@/assets/images/digital/news/96.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/484.html"
        },
        {
          title: "基于ZTMap助力传统道路交通管理向“智慧”发展转型升级",
          desc:
            "随着社会主义市场经济时代的不断发展，智慧交通管理可视化系统的搭建，为未来城市交通建设提供了的一个全新的模板，通过数字孪生、 ZTMap3D等综合技术的集成和使用，提升了交通管理领域的信息覆盖、事件实时性和管理可靠性的交通信息服务体系，使“人－车－路”三者之间的联系以新的方式呈现，真正做到人民交通为人民服务，智慧系统让交通发挥更大的作用...",
          date: "2022-07-27",
          img: require("@/assets/images/digital/news/97.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/497.html"
        },
        {
          title: "基于ZTMap3D建设智慧楼宇建筑数字孪生运维管理平台",
          desc:
            "上海臻图信息是一家致力于空间信息软件研发、大型企业级信息化系统建设、行业定制信息化产品开发公司，公司的主旨就是为给用户提供更加放心安全的技术服务。通过空间信息二三维可视化产品的自主技术研发，推动智慧楼宇的技术发展，共建美好智慧城市...",
          date: "2022-07-27",
          img: require("@/assets/images/digital/news/98.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/495.html"
        },
        {
          title:
            "绿色双碳目标发展：ZTMap三维融合渲染平台打造数字孪生智慧电力运维保障系统",
          desc:
            "运用ZTMap室内外一体化渲染实现室外地图和室内地图无缝渲染切换，实现了变电箱、变压器、开关柜等重要保电设备及环境的全面实时感知查看；并在设备上展示出不同的颜色代表设备的不同运行状态。通过物联网、云计算等智能化分析，当设备出现告警、故障异常时，将自动监测分析出来的结果一并传达到管理员移动端设备和后台管理上，管理员可根据后台传...",
          date: "2022-07-27",
          img: require("@/assets/images/digital/news/99.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/494.html"
        },
        {
          title: "以强大数字孪生技术为基础底座，进一步完善智慧安防保障体系 ",
          desc:
            "对数字孪生安防关键技术的有效应用，一方面能够让国民的安全得到保障，降低多种群众人身财产安全的损失的情况的出现，使得人们的生活质量能够得到保障。另一方面则能够有效地防止入侵，规避关键性信息泄露的情况的出现，创造出良好的环境，保障我国的和谐与稳定发展。数字安防技术不断得在 优化，让其能够发挥更大的作用，带来更多的良性影响力...",
          date: "2022-07-27",
          img: require("@/assets/images/digital/news/100.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/493.html"
        },
        {
          title: "数字孪生技术在智慧城市规划中的发展影响及其应用",
          desc:
            "近年来城市化的发展给人们的生活带来了很多便利，但同时城市问题也逐渐显现。2020年新冠疫情的爆发更突出了城市管理中的问题。数字孪生技术的出现给这些问题带来了可用的解决方案。本文将介绍数字孪生技术的起源和当前趋势，提出数字孪生技术的三种模型的介绍和对比，同时列举数字孪生技术在交通场景、安全预警场景和城市规划场景的应用并给出结语...",
          date: "2022-07-27",
          img: require("@/assets/images/digital/news/101.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/492.html"
        },
        {
          title: "基于数字孪生的数字电网展望与探析",
          desc:
            "在数字孪生背景下，数字电网建设工作需要进行创新与完善，通过加强物理电网设置、加强感知层设置、加强传输层设置等不同方式，促使数字电网可以将自身价值与优势发挥出来，为后续相关工作的落实打下良好基础。 在云计算技术、大数据技术以及先进互联网技术快速发展背景下，推动第四次工业革命的发展，进一步强化信息采集、信息存储、信息分析与信息共享...",
          date: "2022-07-27",
          img: require("@/assets/images/digital/news/102.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/491.html"
        },
        {
          title: "臻图信息可视化预警系统推动工厂安防迈向智能化",
          desc:
            "上海臻图信息技术公司运用ZTMapGIS一张图搭建出来的智慧安防管理可视化平台，通过深度开发智能场景应用技术，打通了设备、数据之间的壁垒，实现数据共享。以可视化数据关联的形式，在IOC可视化平台之上进行综合集成展示，根据角色、职能、业务的维度，并与三维场景的互动操控，为日常运营管理提供可视化操控入口，实现所见即所得的智能管理手段和方法...",
          date: "2022-08-03",
          img: require("@/assets/images/digital/news/103.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/503.html"
        },
        {
          title: "探索“智慧社区”发展，打造一体化实用场景新建设",
          desc:
            "当前物联网、信息化、数字化技术在各个领域中发挥出重要作用，在政策和技术推动下，我国智慧社区建设进入了快速发展阶段。上海臻图信息将深入分析社区管理对象、管理手段和管理流程，以网格化管理为抓手，开展社区管理关键技术应用研究，建设智慧社区综合管理一体化平台，最大程度、最低成本的满足业主和管理者的多元化需求，做好智慧社区建设的长远规...",
          date: "2022-08-03",
          img: require("@/assets/images/digital/news/104.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/502.html"
        },
        {
          title: "聚焦关键要素|打造智慧园区综合运营决策平台解决方案",
          desc:
            "为了更好地推进智慧园区的发展，上海臻图信息始终坚持自主技术创新，为行业企业提供智慧园区建设与运营的成功案例，展示先进技术应用场景，分享优秀案例经验，打造智慧园区综合运营决策平台解决方案。同时，公司依托核心产品，深入研究行业应用，在智慧城市、物联网、园区、安防、建筑、安全等领域不断深耕细作，以空间信息可视化和时空大数据分析的创新视角赋能智慧应用，为一体化管理模式提供轻量化的解决方案...",
          date: "2022-08-03",
          img: require("@/assets/images/digital/news/105.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/501.html"
        },
        {
          title: "数字孪生智慧水务管理建设方案 ",
          desc:
            "城市水系是影响和制约城市发展的重要自然环境因素，智慧水务建设将推动我国由传统水利向现代水利转变，是未来实现水资源科学发展的新模式。将智慧水务应用到城市水系建设上，可以借助大数据技术、先进的计算机与通信技术来实现对水资源的及时、准确的数据监测，这也成为城市水资源信息管理的一种必然趋势。这对水务管理信息系统的构建、减少水灾害具有重大价值...",
          date: "2022-08-03",
          img: require("@/assets/images/digital/news/106.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/500.html"
        },
        {
          title: "臻图信息ZTMapGIS系统助力智慧城市建设",
          desc:
            "慧城市综合运营平台以城市为数字基础建设，通过数据的整合和分析，并结合利用ZTMapGIS轻量级空间数据可视化平台软件，对城市各个基础设施以“一张图”进行可视化展示管理；利用数据信息的“实时、感知、全面、精准”的优势，建立在线、全覆盖的智慧城市综合运势态势地图，能够快速有效的预警、调度、处置发生事件，为管理者提供科学有力的支撑，提高管理效率和执行能力，助力智慧城市的高效发展与运行...",
          date: "2022-08-03",
          img: require("@/assets/images/digital/news/107.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/499.html"
        },
        {
          title: "ZTMap赋能数字工厂智慧化|提高生产管控效率，助力透明化工厂建设",
          desc:
            "随着智慧工厂逐渐进入数字化转型的深领域，与物联网的开发性和多种特殊性的结合，实现了智慧工厂工业看板、智慧物流管理、生产现场监管、质量闭环追溯、资源管理控制等多业务智慧化场景融合，加速产业升级，提高企业生产效率。上海臻图将持续夯实自身产品技术的同时，积极聚焦行业核心需求，打造更多满足更多行业需求场景的解决方案，携手更多合作者助力制造工业数字化转型，赋能企业全面提升核心竞争力...",
          date: "2022-08-03",
          img: require("@/assets/images/digital/news/108.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/498.html"
        },
        {
          title: "地质灾害防治可视化智慧管理系统平台",
          desc:
            "汛期是地质灾害易发期，强降雨易诱发泥石流和崩塌、滑坡等灾害。为解决地质灾害防治等问题，臻图信息将充分运用并集成云计算、大数据、物联网、人工智能等现代信息技术，搭建地质灾害防治可视化系统平台，利用多种新技术手段，助力提升地质灾害预警手段，能够为地质灾害监测预警及应急响应提供更加科学的决策依据...",
          date: "2022-08-12",
          img: require("@/assets/images/digital/news/109.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/504.html"
        },
        {
          title: "天然气地下管道智慧应急指挥系统平台，24小时为你保驾护航",
          desc:
            "上海臻图信息ZTMap3D可视化智慧应急指挥管理系统，摒弃了传统的运维管理模式的缺陷，运用数字化、可视化、智能化技术，将多种复杂的环境在虚拟仿真系统下，以直观可视化理解的形式展现，大幅的缩短响应时间，加速响应排查，提升了信息交互和有效管理的效率。将ZTMap可视化技术和智能监管相结合，打造有效的预警方案和应急指挥处理系统，保障了天然气在运营生产中能够安全、绿色、高效、有序地平稳进行，全面构建应急指挥处理中心的智能化运行...",
          date: "2022-08-12",
          img: require("@/assets/images/digital/news/110.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/506.html"
        },
        {
          title: "上海臻图信息3DGIS+BIM技术助力智慧城市地下综合管廊建设",
          desc:
            "臻图信息基于GIS+BIM技术搭建全方位立体综合管廊精细化渲染模型，系统集成地理信息、设备监测、预警信息、工单信息、智能巡检、运行监控、指挥调度等运营管理，支持各系统之间无缝对接，实现信息共享、工作协同。方便管廊运维管理人员可视化管理，实时查看系统采集到的监测数据和监控画面，并运用智能巡检功能，确保在有限空间内保障城市的安全运营...",
          date: "2022-08-12",
          img: require("@/assets/images/digital/news/111.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/507.html"
        },
        {
          title: "臻图信息基于GIS可视化构建智慧消防平台，全面保障城市安全运营",
          desc:
            "智慧消防通过人防、物防、技防联动，为城市建设全面筑牢消防安全屏障。从设备、流程、人员三方面全面进行升级，实现消防工作的数字化和智能化的发展。从消防风险可视到消防可管可控，大幅的提高了消防管理效率和消防可控，控制灾害危害风险，减少事故发生，为城市建设和民众生命财产安全提供安全保障...",
          date: "2022-08-12",
          img: require("@/assets/images/digital/news/112.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/508.html"
        },
        {
          title: "基于ZTMapGIS打造智慧环保指挥中心平台，强化环境监测精细化管理",
          desc:
            "在“碳达峰、碳中和”的背景下，智慧环保推动了环保产业优化升级，同时也将会带来更多机遇与挑战。上海臻图信息技术有限公司坚持以技术创新推动生态环境大数据建设，运用ZTMap3DGIS技术助力环保监测事业向数字化和智慧化发展，逐步提升环境管理能力，不断改善生态环境质量，最终实现环境经济的协调发展...",
          date: "2022-08-12",
          img: require("@/assets/images/digital/news/113.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/509.html"
        },
        {
          title: "臻图信息全面推动智慧监狱建设高质量发展",
          desc:
            "上海臻图信息基于ZTMapGIS、BIM、数字孪生、图像处理、高精准度定位等系统和技术的应用，建立智慧监狱可视化大屏，实现了对监狱内特定场景、特定建筑、特定人员的可视化行为识别防控和精准化定位。臻图信息将高精度定位技术与业务需求相融合，系统广泛应用于监狱、看守所、戒毒所、校园、安防、工业区、住宅小区、园区等多种行业。智慧监狱系统以大数据、智能分析为基础，满足了智慧监管的业务需求，提高了风险预警和突发事件处置能力，全面推动监狱事业建设高质量发展...",
          date: "2022-08-12",
          img: require("@/assets/images/digital/news/114.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/510.html"
        },
        {
          title: "聚焦“新基建”，臻图信息打造智慧交通仿真最佳方案！",
          desc:
            "臻图信息紧跟“新基建”时代政策的发展，运用数字孪生技术，加强新兴科学技术与产业设备的融合，在仿真推演测试中跑出最优解，并应用到实际场景中去，打造智慧交通仿真最佳方案，积极推动智慧城市的发展。智慧仿真系统除了运用在交通运输行业，还可应用于城市基础设施建设、制造业、医药制造、农业等多种行业...",
          date: "2023-01-03",
          img: require("@/assets/images/digital/news/115.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/517.html"
        },
        {
          title: "园区定位导航服务系统再升级，助力园区智慧化管理",
          desc:
            "臻图信息致力于数字化场景的应用发展，专注于大数据、云平台和可视化技术应用，通过图表、平面图、三维场景以及视频形式对商业园区进行形象化展示，使各类信息能够直观清晰地展示，实现大数据运营模式，为客户进一步提高服务质量和管理水平，提升用户的体验。为加强园区管理和运行效率，提供一体化、轻量化的管理模式解决方案...",
          date: "2023-01-03",
          img: require("@/assets/images/digital/news/116.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/514.html"
        },
        {
          title: "臻图信息以科技创新赋能交通管理智慧化发展",
          desc:
            "智慧交通的构建对我国的长久可持续发展意义重大，臻图信息运用“一网统管”城市智慧交通治理方式，解决高峰时期拥堵路段的通行能力和交通运输能力，降低交通事故发生率。以科技创新推动交通道路治理现代化的建设，提高城市的交通组织运行效率，让人们的出行更加高效、便捷、舒适，并且有助于低碳经济的发展，提高国民生活水平...",
          date: "2023-01-03",
          img: require("@/assets/images/digital/news/117.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/516.html"
        },
        {
          title: "【展馆攻略】展馆室内精准定位导航服务，便捷无忧，所见必达！",
          desc:
            "随着城市化进程的推进，精准室内导航系统不仅针对智慧展馆，还可应用于大厦、商场、机场、高铁站、地铁站等等诸多地形复杂领域，还有针对交通复杂路段搭建的精准导航系统服务，为城市发展带来了更加安全、高效的运作方式。随着信息技术的发展，室内定位导航系统更加立体化，更加精准。臻图信息积极发展空间计算技术...",
          date: "2023-01-03",
          img: require("@/assets/images/digital/news/118.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/513.html"
        },
        {
          title: "臻图信息赋能数字化变革，打造智慧商场新模式",
          desc:
            "臻图信息以信息技术为支撑，打造可视化智慧商场管理新模式，使招商、经营、管理与服务实现无缝对接，提升了管理运维效率，使得商业管理更加直观、有效，辅助管理者对商业管理层面优化决策，实现了商场内部精确、高效、互联互通的全方位项目管理。从而改善商场的运营管理，加快了商场智慧管理升级步伐，进一步提高商业体的市场竞争力...",
          date: "2023-01-03",
          img: require("@/assets/images/digital/news/119.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/512.html"
        },
        {
          title: "基于数字孪生+GIS+BIM技术，打造智慧展馆运营管理新模式",
          desc:
            "臻图信息全力打造的智慧展馆可视化管理系统，充分发挥了智能化和数字化优势，将多种可视化场景及设备管理实现一屏管控，为运营管理人员提供决策依据，让展馆管理变得可视、可管、可控，有效降低了展馆维护成本，提升了危机处置效率，全面推动展馆智慧管理新发展...",
          date: "2023-01-03",
          img: require("@/assets/images/digital/news/120.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/511.html"
        },

        {
          title: "臻图信息基于GIS+BIM技术助力城市地下综合管廊绿色建设发展",
          desc:
            "臻图信息3D可视化地下综合管廊系统绘制了“一张图”管理，实现对地下管廊管线实时监测和风险预警，以感知、决策、管理的综合地下管廊为指导，打造了运维一体化管理运维体系，全面构建城市地下综合管廊安全运营与智慧管控，从而提高城市绿色化、精细化、智能化管理水平，实现对城市综合地下管廊全天候、智慧化的统一运维监管...",
          date: "2023-07-17",
          img: require("@/assets/images/digital/news/121.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/518.html"
        },
        {
          title: "布局新基建，臻图信息赋能建筑产业绿色高质量发展",
          desc:
            "随着新基建、5G、大数据、AI、数字孪生的不断深入发展，未来将解锁更多应用场景，实现多元化的跨界合作。臻图信息将依托自主创新研发的一系列空间信息二三维产品，并结合BIM、物联网、移动互联等技术，实现建筑行业智慧化和精细化的完美结合，对楼宇建筑管理中的每个流程和环节进行前期规划、过程管控和后期分析...",
          date: "2023-07-17",
          img: require("@/assets/images/digital/news/122.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/519.html"
        },
        {
          title: "赋能乡村振兴，臻图信息助力农业智慧化建设",
          desc:
            "臻图信息利用信息技术和数字化手段，将加快推进数字农业农村发展，在农业生产和运营中持续推进数字技术与生产经营服务的深度融合，不断提升农业精细化管理水平、作业质量和效率，赋能农业高质量发展，实现乡村振兴，引领农业数字化转型。未来，随着云计算、物联网、人工智能等领域新技术和成果的进一步应用，农业生产经营...",
          date: "2023-07-17",
          img: require("@/assets/images/digital/news/123.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/520.html"
        },
        {
          title: "臻图信息赋能数字孪生城市打造多种应用场景",
          desc:
            "臻图信息专注于空间信息可视化和空间分析技术的研究和开发，致力于为智慧城市、物联网、数字孪生等行业可视化应用赋能；形成了数字孪生城市、智慧园区、智慧社区、智慧安防、智能建筑、智慧农业、智慧交通、智慧安全、智慧市政、智慧旅游等众多典型行业的空间可视化应用解决方案，助力企业管理和行业发展...",
          date: "2023-07-17",
          img: require("@/assets/images/digital/news/124.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/521.html"
        },
        {
          title: "臻图信息打造“城市大脑”让城市管理更加智能化",
          desc:
            "未来，臻图信息将继续完善3D GIS地图和智慧城市的应用，全面升级数字孪生智慧城市平台，进一步整合各类数据资源，推进数字管理的信息共享，构建线上线下一体化智能服务体系平台，从而打通城市治理和社会服务各个环节的围栏，保障各项数据精准生产和协调社会服务资源，让智慧城市的真正价值被创造出来...",
          date: "2023-07-17",
          img: require("@/assets/images/digital/news/125.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/522.html"
        },
        {
          title: "双碳攻坚，臻图信息给电力管理配上“智慧大脑”",
          desc:
            "通过ZTMap3D可视化平台整合打造的电力能源“智慧大脑”系统，是一款轻量级空间数据软件。系统通过从宏观到微观海量三维模型数据渲染，并融合地理、技术、管理、业务信息，提供数据共享、跨平台交互、智能感知等服务模式，可实现快速响应上层业务应用，最终实现电力能源和能耗的精细化管理，为国家电力能源...",
          date: "2023-07-17",
          img: require("@/assets/images/digital/news/126.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/523.html"
        },
        {
          title: "开启时代新篇章，臻图信息推进市域治理现代化",
          desc:
            "臻图信息通过对市域治理服务平台进行数字实景可视化搭建，不断优化调整市域治理运行管理平台功能，和不断完善各自信息系统网络安全，与市治理运行管理中心实现系统互联和信息资源共享，制定完善的市域治理运行机制体系，确保全市安全生产形势保持稳定，满足广大人民群众需要，打造共建共治共享的社会格局新理念...",
          date: "2023-07-27",
          img: require("@/assets/images/digital/news/127.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/524.html"
        },
        {
          title: "“双碳”战略推动，臻图信息智慧路灯系统助力城市发展",
          desc:
            "智慧灯杆作为新型基础设施的代表之一，承载着多功能合一的环境监控及交互职能，在数据收集、分析、决策、部门联动、自主调节等功能上，大幅度的节省的电力资源，同时也提升了大型公共照明的管理水平，减少了运行维护的成本。臻图信息将在国家政策“双碳”目标的引导下，依托数字孪生技术，进一步推动智慧城市绿色照明系...",
          date: "2023-07-27",
          img: require("@/assets/images/digital/news/128.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/525.html"
        },
        {
          title: "臻图信息以数字孪生为基础，构建机房智慧化管理新环境",
          desc:
            "臻图信息结合传统机房现状，以数字孪生底座为基础，横向拉通各域数据，汇聚机房设备、环境、资产等信息，构建以大数据、人工智能、图像识别与处理、机器人等技术为引领的“标准、安全、稳定、绿色、节能”的一站式服务，进一步降低企业运营成本，全面提升运维保障自动化安全管控水平...",
          date: "2023-07-27",
          img: require("@/assets/images/digital/news/129.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/526.html"
        },
        {
          title: "臻图信息：数字技术推动智慧楼宇开启新模式",
          desc:
            "臻图信息搭建的智慧楼宇建筑集成系统平台集结构、系统、服务、管理、优化为一体，满足了楼宇内管理、监控、运维、安防、能耗等功能需求，让管理员能够直观地掌握楼宇运营中的有效信息，使复杂的智能楼宇运维管理信息易于表达，实现透明可视化管理，进而提高运维管理和监控管控效率，构建安全、高效、绿色、节能的建筑环境体系...",
          date: "2023-07-27",
          img: require("@/assets/images/digital/news/130.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/527.html"
        },
        {
          title: "臻图信息打造智慧养老系统管理平台，为养老事业保驾护航",
          desc:
            "臻图信息智慧养老系统不仅适用于社区养老，还可以针对养老院、护理院、老年福利院、老年公寓、老年康复中心、酒店式老年公寓等养老机构实现系统对接，系统运用三维可视化大屏可以清晰直观地展示重点监测人员信息及日常护理信息。通过智能化分析手段对老人身体状态实时监测，能对紧急情况做及时响应，对异常处理事件...",
          date: "2023-07-27",
          img: require("@/assets/images/digital/news/131.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/528.html"
        },
        {
          title: "臻图信息搭建土壤墒情监测应用平台，推进现代农业信息化发展”",
          desc:
            "臻图信息积极响应国家号召标准，利用信息化技术建设全周期管理的土壤墒情系统平台，有效地提升了农业的智能化水准和自动化水平，大幅的提高农田的土地利用率和农业的生产率，为公众提供信息服务，为农业生产管理提供信息化决策依据，助力现代农业发展...",
          date: "2023-07-27",
          img: require("@/assets/images/digital/news/132.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/529.html"
        },

        {
          title: "臻图信息构建数字孪生港口船舶停靠管理系统，赋能港口创新发展",
          desc:
            "依托于数字孪生、物联网、实景三维等先进技术在港口等各领域的应用愈加广泛，智慧港口管理已进入崭新的发展时代。未来，臻图信息将继续深耕空间信息化科技创新，致力于智慧港口、智慧园区、智慧城市、智慧社区、智慧安防、智能建筑、智慧安全等众多典型行业的智慧应用解决方案，以数字孪生赋能传统港口创新发展...",
          date: "2023-08-03",
          img: require("@/assets/images/digital/news/133.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/531.html"
        },
        {
          title: "臻图信息打造高速服务区智能化解决方案，赋能“区路协同”发展",
          desc:
            "服务区作为高速公路上的重要基础设施，承担着不可或缺的服务和保障功能。近两年通过互联网、人工智能、大数据、区块链等新技术的应用，将现代信息技术与服务区的管理和服务功能相结合，对传统服务区的硬件设施和管理方式进行升级与改造，为广大旅客提供更加便捷、高效、人性化的服务。臻图信息为整体提升服务区的现代化管理水平，改善旅客...",
          date: "2023-08-03",
          img: require("@/assets/images/digital/news/134.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/532.html"
        },
        {
          title:
            "上海臻图信息将以数字孪生技术开发，赋能智慧港口照明自动化系统新解决方案",
          desc:
            "港口是位于海、江、河、湖、水库沿岸，具有水陆联运设备以及条件以供船舶安全进出和停泊的运输枢纽。一直以来，港口码头作为进出口贸易的最大运输枢纽平台，国内港口的作业生产均采用是24小时全天候作业模式，那么为了保障港口安全有序的正常作业，规模庞大的照明系统就显得尤为重要，而照明所消耗的电力巨大，面对资源紧张的格局上，将利用物联网、云计算、大数...",
          date: "2023-08-03",
          img: require("@/assets/images/digital/news/135.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/471.html"
        },
        {
          title: "浅谈智慧景区发展，臻图信息运用数字孪生打造智慧景区",
          desc:
            "臻图信息以“数字孪生+旅游景区”为方向，打造旅游景区发展建设的新生态、新模式、新科技。通过对旅游景区赋能与多设备、多行业融合，提供一体化运营管理系统解决方案，利用智能AI分析消费者行为及轨迹数据，形成智能服务闭环，为景区运营管理层提供智能化、数字化服务技术...",
          date: "2023-08-03",
          img: require("@/assets/images/digital/news/136.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/533.html"
        },
        {
          title: "以数字孪生技术赋能交通发展，打造智慧钢铁物流运输新模式",
          desc:
            "臻图信息围绕着绿色低碳、智能制造、节能环保，以加快数字化赋能、推动智能制造为新发展理念，通过完善智能物流的监测与感知系统，建立全方位多层次的智能物流大数据集成平台，将数字孪生和信息物理系统相结合，实现了物流运输行业的智能化、集中管制，全面提升了物流运输的智能化管理水平、智慧优化决策和精准控制执行，有效推动中国钢铁交通行业的智能化转型...",
          date: "2023-08-03",
          img: require("@/assets/images/digital/news/137.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/534.html"
        },
        {
          title: "臻图信息积极搭建智慧社区功能模块，推进智慧城市发展建设",
          desc:
            "臻图信息积极响应国家政策的引导，响应各地区的创新实践建设，依托数字孪生、二三维GIS地理信息技术，从实现城市网格之间的无缝连接到区域的无缝管理。在摸清城市网格中各种人、事、地、物、情信息的情况下，通过各子系统的整合和辅助，在日常工作中，通过可视化、精细化管理，完成及时、常态、全天候的社区服务管理，助力智慧城市治理建设发展...",
          date: "2023-08-03",
          img: require("@/assets/images/digital/news/138.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/535.html"
        },
        {
          title: "臻图信息利用数字孪生构建生态环境智慧监测系统",
          desc:
            "生态环境监测是生态环境保护的基础，是生态文明建设的重要支撑。臻图信息利用自主研发的数字技术，搭建生态环境智慧监测系统平台，打造城市环境一体化保护和系统治理体系。从感知效率、数据融合、技术应用、平台搭建等多维度完善自然资源“一张图”基础平台，提供一个数据更精准、画面更动态的开放性监测平台...",
          date: "2023-08-11",
          img: require("@/assets/images/digital/news/139.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/536.html"
        },
        {
          title: "臻图信息：数字孪生BIM技术搭建智慧园区楼宇运维可视化平台",
          desc:
            "智慧园区基于臻图ZTMap系列轻量化三维融合渲染平台，实现了宏观二三维GIS地理信息、微观建筑物室内BIM模型的统一集成渲染和无缝漫游体验，从易操作、高渲染的客户角度出发，搭建了一套3D可视化的智慧园区管控平台。系统平台整体界面内容紧密结合园区业务，提供设备安防、楼宇态势、能耗分析、运营管理等功能，推动园区各业务之间的信息数据共享，提高信息化监管能力...",
          date: "2023-08-11",
          img: require("@/assets/images/digital/news/140.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/537.html"
        },
        {
          title: "臻图信息跟进新基建建设，构建“智慧铁路”“指挥调度”管理系统",
          desc:
            "依托ZTMap3D界面连接业务管理数据和传感设备的自动采集数据，建立数据体系库的垂直管理模式，打破数据孤岛，实现信息共享；为管辖区域内每一个节点提供全面管控、动态感知、信息追溯和管理决策支持，整体提升列车运行过程中动态监管、应急响应和多方协作的能力。构建智慧铁路一体化指挥调度平台，实现铁路关键设施的运行状态在线监测、远程诊断和智能维护，提高全路段列车指挥调度和运输管理...",
          date: "2023-08-11",
          img: require("@/assets/images/digital/news/141.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/538.html"
        },
        {
          title: "臻图信息搭建智慧水务管理平台，保障供水安全运行",
          desc:
            "数字化时代，臻图信息将以3D融合渲染平台、VR实景3D平台、GIS平台为表现形式，以应用为导向，专攻GIS、BIM、VR、AR等信息可视化相关关键技术领域。在物联网领域，深耕技术创新导向，致力于为客户创造价值，为社会贡献智慧，开拓进取，务实进取，打造空间信息可视化服务领导品牌...",
          date: "2023-08-11",
          img: require("@/assets/images/digital/news/142.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/530.html"
        },
        {
          title: "臻图信息：以数字孪生技术服务社会，推动企业高质量发展",
          desc:
            "系统通过ZTMapGIS和数字孪生技术实现交互应用场景，结合进出港船舶、异常轮船、车辆、设备、安全预警、仓库监控等综合应用，实现2D和3D渲染无缝对接，构建超精细模型还原真实场景细节；管理人员可点击相应设备即可显示其运行情况和信息分析，再现港区真实场景，为港口管理部门提供更加合理高效的船舶运行监管服务...",
          date: "2023-08-11",
          img: require("@/assets/images/digital/news/143.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/539.html"
        },
        {
          title: "臻图信息以数字孪生赋能智慧文旅新发展",
          desc:
            "采用数字孪生和臻图信息自主研发的ZTMap3DGIS引擎技术，利用实时渲染、数据交互、仿真建模等技术对景区及周边地形、交通路网、生态植被等环境进行动态三维智慧景区输出。同时，平台通过激光点云技术对文物建筑外观及纹理进行高精细化建模，为用户提供虚实要素进行交互操作，使得用户通过数字化方式可以深入体验了解文物及建筑的独特魅力，实现城市景区数字空间的全息投影...",
          date: "2023-08-11",
          img: require("@/assets/images/digital/news/144.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/540.html"
        },
        {
          title: "未来城市的畅想，数字孪生城市的落地",
          desc:
            "你眼里的未来城市是什么样的？是川流不息的繁荣街景，是有序切换的交通信号灯，是纵横交错密如蛛网的道路，是地下数亿万条管道的盘根错节，是鳞次栉比的高楼林立，是自动驾驶汽车自由穿行……实际上，未来城市远远地超出我们的想象。 目前，以5G通信、大数据、云服务、人工智能、区块链等创新技术为代表的数字浪潮席...",
          date: "2023-08-18",
          img: require("@/assets/images/digital/news/1.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/346.html"
        },
        {
          title: "数字孪生城市概念分析及建设方案详解",
          desc:
            "数字孪生城市的内涵 （一）数字孪生 据美国航空航天局（NASA）权威性定义，数字孪生就是指充分运用物理模型、传感器、运作历史等数据，集成多学科、多物理量、多尺度、多概率的模拟仿真全过程，在虚拟空间中完成映射，进而反映相对应的实体设备的生命周期全过程。简而言之，数字孪生便是将现实世界的物理体...",
          date: "2023-08-18",
          img: require("@/assets/images/digital/news/2.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/356.html"
        },
        {
          title: "新时代背景下数字孪生技术发展的详情分析",
          desc:
            "目前，数字孪生技术不只运用在制造业，它早已彻底进入了物联网，人工智能和大数据分析的融合世界。伴随着更繁杂的“事物”与生成数据的能力联系在一起，拥有数字等同物使数据科学家和其他IT行业人员，能够以最高的效率优化布署虚拟场景。 1、到底什么是数字孪生？ 数字孪生是充分运用物理模型、传感器更新、运行...",
          date: "2023-08-18",
          img: require("@/assets/images/digital/news/3.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/367.html"
        },
        {
          title: "数字孪生技术的详情分析及应用场景简介",
          desc:
            "数字孪生好像已经变得无所不在，成为了各行各业各个领域实现数字化的神丹妙药。2016-2018年，Gartner接连三年将数字孪生列入十大战略科技发展趋势。2019年，Gartner认为数字孪生处在期望膨胀期顶峰，将在未来5年产生破坏性创新。那么，数字孪生到底是什么，是一种技术，还是一种思想、方法...",
          date: "2023-08-18",
          img: require("@/assets/images/digital/news/4.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/376.html"
        },
        {
          title: "数字孪生技术的现代化应用详情分析及发展意义简述",
          desc:
            "生产加工阶段是数字孪生技术的一个重要的应用场景。目前个性化、多元化的市场消费需求成为主流，制造业正面对日渐激烈的市场竞争，面临着极大的时间、成本、质量、产品差异化等方面的压力。企业很难适应市场环境的突然变化，比如受此次受疫情的影响，怎样运用技术手段迅速实现复工复产，是每个制造企业所需要面临的问题...",
          date: "2023-08-18",
          img: require("@/assets/images/digital/news/5.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/387.html"
        },
        {
          title: "数字孪生技术在建筑行业的应用详情分析",
          desc:
            "世界知名分析机构Gartner公布的2019年十大战略性技术发展趋势，这些发展趋势并非概念技术，而是已经有了关键性的突破，将发展成更广泛的应用，其高度波动性在未来五年内将达到临界点。 这些发展趋势中包含人工智能、数字孪生、边缘计算、量子计算、沉浸式技术、区块链、智能空间等，同时这些技术之间的关联...",
          date: "2023-08-18",
          img: require("@/assets/images/digital/news/6.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/405.html"
        },
        {
          title: "新时代创新性数字孪生技术在交通运输领域的应用",
          desc:
            "交通仿真软件可以根据OD信息，分析计算一段时间内公路交通变化数值。GIS支持在三维场景中，将变化数值利用道路拓扑规则转换为每一条车道上的车辆模型运动轨迹，通过将抽象化的数值变化呈现为动态性的虚拟场景，为交通模拟仿真分析提供交通模拟呈现的功能，利用可视化的技术让专业的数据可以为更多的非专业人士所精确了解，从而为专业数据搭建更多的应用场景...",
          date: "2023-08-25",
          img: require("@/assets/images/digital/news/7.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/328.html"
        },
        {
          title: "智慧城市的发展必然趋势-数字孪生城市的创建",
          desc:
            "信息爆炸时代的当今世界，从来都不欠缺创新科技新理念。每一年都会有新热点推出，云计算、大数据、物联网、VR（虚拟现实）、AR（增强现实）、区块链、人工智能、数字孪生、5G（第五代移动通信技术）等新词汇不断涌现。科技创新不仅仅给社会经济发展带来极大推动力，也对人类社会甚至人类自身的演变造成了深刻的影...",
          date: "2023-08-25",
          img: require("@/assets/images/digital/news/8.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/327.html"
        },
        {
          title: "BIM信息技术助力数字孪生城市打造智能化建筑",
          desc:
            "国家住建部、国家工信部等9个部门联合发文《加速最新型建筑工业化发展的若干意见》，将BIM技术做为发展最新型建筑工业化的主要信息技术手段，BIM的前途可以说是一片大好! BIM以建筑工程项目各类有关信息数据做为基础，进行建筑模型的构建，利用数字信息仿真模拟建筑物所具备的真实信息内容。BIM应用在我国已经有十数年了，伴随着BIM规范的不断地构建和完善，各地区政策的不断地落实...",
          date: "2023-08-25",
          img: require("@/assets/images/digital/news/9.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/326.html"
        },
        {
          title: "基于物联网服务平台的数字孪生体系现状分析",
          desc:
            "数字孪生体是描述物理世界和数字空间的定义管理体系，它即是一种技术，也是一种新范式。自2010年宣布问世至今，受到了广泛的关注。工业4.0研究所2015年启动对数字孪生体的科学研究，至今获得了丰厚的成效。 以往五年期内，工业4.0研究所陆续完成了《数字孪生体发展史》、《数字孪生关键技术》、《数字...",
          date: "2023-08-25",
          img: require("@/assets/images/digital/news/10.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/274.html"
        },
        {
          title: "数字孪生技术现状分析及发展趋势探讨",
          desc:
            "今年的技术趋势报告继续在开头回顾了11年来技术趋势的发展，显示了技术趋势时间演变的全过程、最新的宏观科学技术力量为业务变革基础带来的共生利益和不久的未来新兴科学技术力量。 随着企业应对不断变化的技术并迅速作出反应，期望更多的IT领导者和财务领导者更加紧密地合作，寻求灵活的融资方法。 一、20...",
          date: "2023-08-25",
          img: require("@/assets/images/digital/news/11.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/278.html"
        },
        {
          title: "数字孪生技术在智慧城市中的应用分析",
          desc:
            "在信息化飞速发展的当下，城市的发展趋势已经由“数字化”时期进入“智慧化”时期，再到“新数字时期”。数字城市的总体目标是将现实世界的很多工作搬到网络上，通过通信网络来实现了。智慧城市是在信息港和数字城市的基础上发展起来的新方向。现如今，伴随着各类新技术的发展与运用，愈来愈多的理念层出不穷并运用到城...",
          date: "2023-08-25",
          img: require("@/assets/images/digital/news/12.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/279.html"
        },
        {
          title: "数字孪生城市的建设-智慧可视新理念的探究",
          desc:
            "数字孪生的理念最初是由美国密歇根大学的MichaelGrives教授于2003年明确提出。但其在国内引发广泛性关注，是由于雄安新区的基本建设中明确提出，数字雄安基本建设最主要的创新，是建立与新区共同成长的数字孪生城市，而完成的主要方式，便是在基本建设物理城市的同时，运用物联网感知，聚集各方数据构...",
          date: "2023-09-01",
          img: require("@/assets/images/digital/news/13.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/329.html"
        },
        {
          title: "数字孪生技术助力孪生新时代与智慧城市的整合",
          desc:
            "智慧城市是把新一代的信息技术灵活运用在城市中各个行业基于知识社会新一代创新（创新2.0）的城市信息化管理高等级形态，实现信息化、工业化与城镇化紧密结合，有利于缓解“大城市病”，提升 城镇化品质，实现精细化和动态管理，并提升城市管理效果和改善群众生活品质。2014年，安东尼·汤森在《智慧城市...",
          date: "2023-09-01",
          img: require("@/assets/images/digital/news/14.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/323.html"
        },
        {
          title: "数字孪生重塑建筑产业致力打造全新的智慧城市",
          desc:
            "根据普华永道《2030年全世界建筑业》的预测分析，到2030年，全世界建筑业总产值将增长85%，达到15.5万亿美元，在其中三个国家(中国、美国和印度)位于领先地位，占全世界增长的57%。 但，建筑行业仍在面对四个持续性的挑战：生产力和盈利能力差;项目绩效–主要是时间和预算问题，技术...",
          date: "2023-09-01",
          img: require("@/assets/images/digital/news/15.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/324.html"
        },
        {
          title: "数字孪生技术协助信息物理系统构建数字化城市",
          desc:
            "在过去的综合治理形态中，政府治理主要呈现在制度供给、政策激励、外部约束。“治理”和“管理”一字之差，呈现的则是多方面的差异。 现阶段，就城市信息化发展环节来说 ，正处在从数字化管理升华到智慧化综合治理的历史过渡阶段，网格化精细管理模式将逐渐向数字孪生强智能化自治模式演化。 英国曼彻斯特大学教授、...",
          date: "2023-09-01",
          img: require("@/assets/images/digital/news/16.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/325.html"
        },
        {
          title: "数字孪生技术发展趋势详情分析",
          desc:
            "一、技术性探究和专业性布置 数字孪生体是由物理目标、数字镜像及互动系统组成的一个体系，其成长发育必然经过数化、互动、先知、先觉和共智等几个环节。实验室的技术性方向和专业性布置便是按照这些环节有关的技术来确立的。 1.建模 “数化”是对物理世界数字化的环节。这个环节需用将物理目标表述为电子...",
          date: "2023-09-01",
          img: require("@/assets/images/digital/news/17.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/289.html"
        },
        {
          title: "数字孪生技术结合大数据创建智慧城市体系架构",
          desc:
            "全球物联网、5G、人工智能技术、自动驾驶、虚拟现实技术、深度学习等技术研发和产业发展加速提升，刮起数字化网络化智能化新一轮的浪潮。同时，智慧城市实施过程持续加速，实施內容不断深入，其发展核心理念、推动方式和技术性管理体系不断创新和演变，建设虚拟服务现实、数据驱动整治、智能界定一切的数字孪生城市...",
          date: "2023-09-01",
          img: require("@/assets/images/digital/news/18.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/287.html"
        },
        {
          title: "BIM、三维GIS、CIM等技术共同助力数字孪生城市的建设",
          desc:
            "一、从BIM+GIS到CIM 2018年11月，住房和城乡建设部发布了行业标准《“多规合一”业务协同平台技术标准》的征询意见，激励“有条件的城市，可在BIM应用的基础上建立CIM”。 那么什么叫CIM？首先我们得从BIM讲起。BIM指的是建筑信息模型，简单地说，BIM便是围绕从建筑的设计、施工...",
          date: "2023-09-08",
          img: require("@/assets/images/digital/news/19.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/330.html"
        },
        {
          title: "创新型智慧城市建设共性问题；新时代数字孪生助力顶层设计",
          desc:
            "智慧城市建设进入了新一轮的飞速发展时期。现阶段，我国已经成为了全世界建设智慧城市规模最大的国家，据不完全统计，2017年，全国已有五百多座城市启动或在建智慧城市，智慧城市已经成为了我国推进供给侧结构性变革的关键内容，成为了推进以人为核心的新型城镇化的有效途径，成为了城市可持续性健康发展的关键支撑...",
          date: "2023-09-08",
          img: require("@/assets/images/digital/news/20.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/332.html"
        },
        {
          title: "数字城市响应相关国家政策大力发展数字孪生平台的建设",
          desc:
            "一、前言 中共中央、国务院在对《河北雄安新区规划纲要》的批复文件中要求坚持“数字城市与现实城市同步规划、同步建设”的发展模式，打造出展现多维城市空间的数字平台，数字孪生平台逐步变成创新型智慧城市建设的核心创新性要素之一，变成支撑城市大脑，推动数字城市建设的核心基础。 二、数字孪生与智慧城市 数字...",
          date: "2023-09-08",
          img: require("@/assets/images/digital/news/21.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/331.html"
        },
        {
          title: "数字孪生技术的延伸-工业互联网平台",
          desc:
            "互联网、大数据、人工智能等全新一代信息技术飞速发展，对促进制造业数字化、网络化、智能化过程具有关键作用，尤其是信息技术对数据信息的强大计算和分析能力为制造业发展开拓焕然一新的发展空间，IT和OT的结合愈来愈受到制造企业的关注。伴随着全新一代信息技术与制造业紧密结合发展，工业互联网变为制造业从“显...",
          date: "2023-09-08",
          img: require("@/assets/images/digital/news/22.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/322.html"
        },
        {
          title: "数字化产品体系助推供应链管理系统搭建",
          desc:
            "一、供应链管理的挑战与数字化工具 供应链管理对于制造型公司，尤其是生产制造大中型复杂装备商品、多类别订单式生产制造和全球化购置运营的大中型海外制造公司来讲，重要性显而易见。公司的供应链管理一定是其整体发展战略最重要的有机构成部分之一，牵涉到企业运营的各个方面。 比如：新产品研发过程中，主机厂对其...",
          date: "2023-09-08",
          img: require("@/assets/images/digital/news/23.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/276.html"
        },
        {
          title: "数字化智能房产运用现状及发展趋势分析",
          desc:
            "说到数字化，大家第一时间很有可能会想起VR，AR，AI，大数据和物联网。无论是商业地产从业者还是一般消费者，大家最容易会联想到线上商城，会员管理系统这些，但这些全是商业地产数字化的基本层面，简言之也只是商业地产经营时期的一个辅助软件。 个人觉得，当前时期来说商业地产与数值化技术的结合才只不过刚...",
          date: "2023-09-08",
          img: require("@/assets/images/digital/news/24.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/262.html"
        },
        {
          title: "数字孪生技术的实践应用分析及发展历程回顾",
          desc:
            "生产制造阶段是数字孪生技术的一个关键应用环境。现阶段个性化、多元化的市场消费观念成为了主流，制造行业正面对日趋猛烈的市场竞争，面对着不可估量的时间、成本、质量、产品差异化等多方面的压力。企业很难适应市场环境的突然变化，例如受此次受疫情的影响，如何运用技术手段迅速实现复工复产，是每一个制造企业都要...",
          date: "2023-09-15",
          img: require("@/assets/images/digital/news/25.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/335.html"
        },
        {
          title: "城市规划新征途：数字孪生城市的构建",
          desc:
            "诺贝尔经济学奖获得者约瑟夫·斯蒂格利茨曾说：“中国的城镇化与美国的高科技发展将是深远影响二十一世纪人类发展的两大主题。” 人类文明史上，每次科技大爆发都会再次确定全球城市的经济排名。现如今的信息革命，互联网骨干网沿线的人类城市是数据资源集中地，约瑟夫·斯蒂格利茨说对了一半，世界中心正在向中国的北...",
          date: "2023-09-15",
          img: require("@/assets/images/digital/news/26.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/334.html"
        },
        {
          title: "数字孪生技术在未来智能化生活中的应用方向",
          desc:
            "字孪生是近些年兴起的十分前沿的新技术，简单说便是运用物理模型，应用传感器读取数据的模拟仿真全过程，在虚拟空间中进行映射，以体现相对应的实体的项目生命周期全过程。 在未来，物理世界中的各类事情都将能够应用数字孪生技术展开复制。在工业生产行业，根据数字孪生技术的应用，将大幅度促进物品在设计方案、生...",
          date: "2023-09-15",
          img: require("@/assets/images/digital/news/27.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/281.html"
        },
        {
          title: "数字孪生技术助力智能建筑的发展",
          desc:
            "数字孪生的定义早在2002年就已经出现了，而如今伴随着信息科技的持续发展，数字孪生技术也得到了天翻地覆的转变，可以说是智能建筑的关键。下边，我们就更深层次些解读吧！ 智能建筑的关键—数字孪生技术 一、什么叫数字孪生 DigitalTwin数字孪生根据应用传感器搜集相关物理新项目的实时数据，当做...",
          date: "2023-09-15",
          img: require("@/assets/images/digital/news/28.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/282.html"
        },
        {
          title: "数字孪生技术为我们的生活带来了那些影响？",
          desc:
            "孪生数字也称DigitalTwin、数字双胞胎，自基本概念明确提出至今，数字孪生技术性在不断的迅速演变，不管是对产品的设计构思、生产制造还是服务管理，都形成了极大的推进功效。 一、有哪些发展方向 2018年10月，世界著名研究机构Gartner公布了2019年十大战略技术性趋向，这些趋向中包含...",
          date: "2023-09-15",
          img: require("@/assets/images/digital/news/29.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/283.html"
        },
        {
          title: "数字孪生技术在发电站管理平台中的应用",
          desc:
            "引言 能源是人类社会生存和发展的重要物质基础，人口多、经济发展速度快，因此我国的能源消费总量连续多年处于世界领先地位。我国的能源结构是多煤、少气、贫油，而且风、光、水资源、消费分布不平衡，相应的发电能源也以煤为主，2017年煤炭电装装机总量为10.2亿千瓦，占装机总量的58%，发电量占比67%...",
          date: "2023-09-15",
          img: require("@/assets/images/digital/news/30.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/284.html"
        },
        {
          title: "简单谈一谈数字孪生技术在信息化时代下如何推进电网的数字化发展",
          desc:
            "现如今，数字孪生被广泛的运用在电力、交通、医疗、城市管理等各个行业领域当中，正呈现出非同一般的璀璨光辉。其做为实现数字电网比特和瓦特深度融合目标的重要实现手段，正在不断演进。需要深层次认识和理解数字孪生的本质与机理，明确其对数字电网的价值与作用，推动数字比特革命与能源瓦特革命的有机结合...",
          date: "2023-09-22",
          img: require("@/assets/images/digital/news/31.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/429.html"
        },
        {
          title: "源于现实的数字孪生技术在智慧交通领域有怎样的应用",
          desc:
            "数字孪生，英文名为DigitalTwin（数字双胞胎），简单而言，便是在一个设备或系统的基础上，创建一个数字版的“克隆体”。而本文将为大家着重介绍数字孪生的技术框架及其在智慧交通领域的应用。 1、数字孪生技术框架 数字孪生技术框架可分为三个层级，即数据接入层、计算仿真层和应用层...",
          date: "2023-09-22",
          img: require("@/assets/images/digital/news/32.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/428.html"
        },
        {
          title: "简单说一说数字孪生时代智慧城市运营管理模式的未来",
          desc:
            "数字双胞胎，或称为数字孪生（Digitaltwins，DT）是具备数据功能的城市模型，城市管理者可运用这些模型来仿真模拟现实世界中从道路交通到自然灾害的各类城市压力源。据联合国预测分析，到2050年，全球三分之二的人口将生活在城市地域，这将致使全球将出现43个特大城市...",
          date: "2023-09-22",
          img: require("@/assets/images/digital/news/33.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/427.html"
        },
        {
          title: "数字孪生技术借助城市海量数据打造现代化智慧城市",
          desc:
            "现如今的数字孪生，距离预想中的沙盒系统模拟推演、人工智能决策等功能仍有较大差距。数字孪生（DigitalTwin）这个观念最初可以追寻到MichaelGrieves教授2002年在密歇根大学PLM（产品全生命周期管理）中心对产业界做的一次演讲（虽然没有书面证据，但这仍被广泛觉得是数字孪生的最初来...",
          date: "2023-09-22",
          img: require("@/assets/images/digital/news/34.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/426.html"
        },
        {
          title: "简述智能化时代数字孪生技术如何助力商业领域增强用户体验",
          desc:
            "商业引领者可以开发数字孪生，帮助模糊虚拟世界和物理世界之间的界限，以带来更好的产品并增强用户体验。 带来令人满意的用户体验是每一项业务的重中之重。因此，企业会仔细观察用户体验和行业发展趋势。在数字时代，用户体验变得更为繁杂。从网络上寻找新品牌或通过亲朋好友寻找新品牌，再到在社交媒...",
          date: "2023-09-22",
          img: require("@/assets/images/digital/news/35.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/425.html"
        },
        {
          title: "数字孪生技术如何打造新型智慧城市管理体系概述",
          desc:
            "在刚过去的2019中国国际大数据博览会(以下简称“2019数博会”)上，数字孪生城市做为关键词出现在2019数博会“数字孪生城市建设与产业创新全球论坛”上，在这场论坛中，来自于科研界的中国工程院院士倪光南、工业和信息化部信息化和软件服务业司副司长李冠宇、国家信息中心首席信息师张新红与来自于产业界...",
          date: "2023-09-22",
          img: require("@/assets/images/digital/news/36.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/420.html"
        },
        {
          title: "详细谈一谈数字孪生技术如何为现代化社会带来发展契机",
          desc:
            "伴随着人类进入信息化、数字化时代，人们对虚拟数字化世界的好奇和探寻就从未停止过。如今，数字孪生已开始推动人类生产力革命和升级，改变人们的生产生活方式。 中国是加工制造业大国，产业数字化升级正在推进中，数字孪生的应用有无限广阔的空间，加上政策支持，数字孪生在我国迎来了快速的发展机遇期。 1、数字孪...",
          date: "2023-09-29",
          img: require("@/assets/images/digital/news/37.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/430.html"
        },
        {
          title: "简单聊一聊如今火爆当下的数字孪生技术到底为何物",
          desc:
            "一、数字孪生发展背景 “孪生”的概念起源于美国国家航空航天局的“阿波罗计划”，即搭建两个相同的航天飞行器，其中一个发射到太空执行任务，另一个留在地球上用作反映太空中航天器在任务期内的运行状态，进而辅助工程师深入分析处理太空中发生的突发事件。当然了，这里的两个航天器全部都是真实存在的物理实体。",
          date: "2023-09-29",
          img: require("@/assets/images/digital/news/38.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/431.html"
        },
        {
          title: "信息化时代背景下数字孪生技术与区块链技术的关联应用",
          desc:
            "企业一直以来都很担忧有人生产假冒他的产品。技术无所不在，并且迅速发展。因此，欺诈者构建副本并将其售卖给全无戒心的顾客变得容易得多。并且产品随附的文书工作也很容易复制，进而提升了这些假冒产品的真实性。这类情况不仅仅会给既有品牌造成财务损失，还会造成永久性的名誉损失。数字孪生和区块链可以为我们提供解...",
          date: "2023-09-29",
          img: require("@/assets/images/digital/news/39.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/433.html"
        },
        {
          title: "简述现代化数字孪生技术如何打造智能化建筑",
          desc:
            "数字孪生的理念早在02年就已经出现了，而现如今伴随着科技信息的持续发展，数字孪生技术也获得了天翻地覆的改变，可以说是智能建筑的核心。接下来，我们就更深入些了解一下吧！ 一、什么才是数字孪生 DigitalTwin数字孪生通过运用传感器采集有关物理项目的实时数据，作为物理世界和数字世界之间的桥梁",
          date: "2023-09-29",
          img: require("@/assets/images/digital/news/40.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/437.html"
        },
        {
          title: "探讨一下在科技发达的当下数字孪生技术的起源及运用",
          desc:
            "在科技发达的当下，数字化成为了诸多行业领域正在进行的变革转型。世界各地相继采取措施，将数字化技术运用到能源生产、输送、交易、消费及监管等各个重要环节。相对于能源企业而言，数字化转型既是机遇，也是挑战。 最近几年，数字孪生这个概念引发了大家愈来愈多的关注，从初期在学术界引进这个概念，到现在诸多数字",
          date: "2023-09-29",
          img: require("@/assets/images/digital/news/41.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/435.html"
        },
        {
          title: "详细探究一下何为数字孪生技术，它的来源与价值又为何？",
          desc:
            "我相信很多人都听闻过数字孪生。在过去的几年里，这个词的关注度不断地飙升，经常出现在各种峰会论坛的演讲主题当中，深受行业内外的特别关注。到底何为数字孪生？它又是谁提出来的？它会给人们的生活带来怎样的变化？ 一、数字孪生究竟是什么？ 数字孪生，英文名为DigitalTwin(数字双胞胎)，也称之为..",
          date: "2023-09-29",
          img: require("@/assets/images/digital/news/42.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/436.html"
        },
        {
          title: "数字孪生的盛行-新一轮万亿市场的产业变革",
          desc:
            "下面让我们介绍一下一个在产业界如火如荼，但公众还十分陌生的概念：数字孪生（DigitalTwin）。在解答这个晦涩难懂的概念前，我首先联想到了一个人，原苏联知名的昆虫学家、数学家和哲学家——柳比歇夫。在26岁那年，他独创了一种“时间统计法”，可以通过记录每一天做的每件事情所花费的时间，经过统计分.",
          date: "2023-10-13",
          img: require("@/assets/images/digital/news/43.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/438.html"
        },
        {
          title: "全新的物联网时代数字孪生技术在其中扮演者怎样的角色？",
          desc:
            "现阶段，数字孪生技术不只运用在加工制造业，它早已彻底进入了物联网，人工智能和大数据分析的融合世界。伴随着更复杂的“事物”与生成数据的能力关联在一起，拥有数字等同物使大数据工程师和其他的IT技术专业人员，能够以最高的效率优化部署虚拟场景。 1、到底什么是数字孪生？ 数字孪生是充分运用物理模型、传.",
          date: "2023-10-13",
          img: require("@/assets/images/digital/news/44.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/439.html"
        },
        {
          title:
            "基于BIM+3DGIS物联网技术，实现智慧园区（楼宇）三维可视化管控平台",
          desc:
            "我们知道传统式的园区一直遭遇着各类难题，例如：管理效率低、规章制度没法结合、互联网大数据落实、智能安防工作能力不强、服务项目不及时、经营成本居高、机器设备监管分散化等等一系列问题，而现在基于BIM+3DGIS技术，建立的智慧园区（楼宇）三维可视化的管控平台，以全局模型集成化、模型的优化和轻量化的...",
          date: "2023-10-13",
          img: require("@/assets/images/digital/news/45.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/444.html"
        },
        {
          title:
            "如何利用数字孪生技术，让传统园区管理向智慧园区管理发生新的转变",
          desc:
            "数字孪生技术，是如何开启三维智慧园区管理的新篇章 被国家发改委多次点名的“数字孪生技术”到底是什么，它和智慧园区有什么关联，其实早在几千年前数字孪生就已经出现了，在古代行军打仗必备的军事推理工具，“沙盘”随着时代的发展，数字孪生技术作为重要的数字化手段，深入应用到工业制造和智慧城市建设的当中。",
          date: "2023-10-13",
          img: require("@/assets/images/digital/news/46.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/442.html"
        },
        {
          title: "数字孪生三维可视化平台在城市大脑综合治理中的作用",
          desc:
            "在智慧大脑的综合治理中，为什么会需要到三维可视化这个管理平台？原因在于：能不能达到用户所期望的“知道、理解、看见、看懂”。当一个看不懂的大数据是没有办法给任何人创造有利的价值的。 城市大脑是通过先进的技术、系统、数字平台、数字驾驶舱和应用场景等综合要素组成，通过对海量数据的整合、关联、挖掘和分析...",
          date: "2023-10-13",
          img: require("@/assets/images/digital/news/47.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/446.html"
        },
        {
          title: "智慧展馆 | 基于臻图ZTMAP3DGIS数字孪生技术落地创新智慧展馆",
          desc:
            "随着科技时代的发展和进步，以技术理念、模式等创新为依托，所有行业都在点各种一点点发展，智能时代降临，物联网、虚拟现实、云计算、大数据、5G网络等技术正在颠覆着我们的生活方式，加速改变着我们的消费习惯。当物联网技术设备不断地完善和成熟时，利用数字孪生技术，不断的优化，这样可以更有效地帮助使企业、政...",
          date: "2023-10-13",
          img: require("@/assets/images/digital/news/48.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/449.html"
        },
        {
          title: "数字孪生技术在企业运营管理体系中的应用详情",
          desc:
            "全新一代电子信息技术在加工制造业中的深入运用，引起传统化产品研发模式的转型。本文讲述运用数字化线索和数字孪生展开复杂性产品全生命周期业务流程建模与模拟、动态性预测和分析，实现了数字化空间与物理学空间虚实映射的产品研发与定义、模拟与分析、验证与核对的业务闭环管理。最后结合航天工业智能制造系统构架...",
          date: "2023-10-20",
          img: require("@/assets/images/digital/news/49.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/286.html"
        },
        {
          title: "数字孪生助力智慧城市智能化发展",
          desc:
            "做为在数据可视化行业的重度参加者，一线印证了诸多HTML5/Web化、2D/3D化的新项目在工业领域运用落地。根据HT执行的数以百计工业物联网2D3D数据可视化运用实例综合在了智慧城市基本建设。 2020年，实行数字孪生，大家再度奉献出众多实例表明与演示。期待能激起制造行业和学术研究工作人员对数...",
          date: "2023-10-20",
          img: require("@/assets/images/digital/news/50.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/275.html"
        },
        {
          title: "说一说工业互联网与数字孪生之间的关系",
          desc:
            "今年 2月18日,美国工业互联网联盟（IndustrialInternetConsortium，IIC）正式公布《工业应用中的数字孪生：定义，行业价值、设计、标准及应用案例)》市场研究报告（下面通称“市场研究报告”）,致力于为寻找“降本、提质、增效”有效途径的商业服务领导者、系统架构师及其在数字...",
          date: "2023-10-20",
          img: require("@/assets/images/digital/news/51.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/277.html"
        },
        {
          title: "数字孪生城市的创建大力推动智慧城市全面实施",
          desc:
            "全球物联网、5G、人工智能、无人驾驶、虚拟现实、深度学习等技术研发和产业化快速提升，掀起数字化网络化智能化新一轮的浪潮。与此同时，智慧城市全面实施进程不断加速，全面实施内容不断深入，其创新发展理念、持续推进模式和技术体系不断更新和演变，构建虚拟服务实际、数据驱动治理、智能定义一切的数字孪生城市将...",
          date: "2023-10-20",
          img: require("@/assets/images/digital/news/52.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/318.html"
        },
        {
          title: "全国首个数字孪生动态仿真港口亮相！",
          desc:
            "随着三号泊位交工验收第1箱顺利起吊，在智能拖车上平稳落位，妈湾港建设取得重大成就，从传统码头华丽变身为智慧港，为深圳经济特区建立40周年献上了一份厚礼。 焕然一新的妈湾港 妈湾智慧港是深圳西部港区打造粤港澳大湾区首个、乃至全球领先的智慧型港口、世界级强港的起点。 妈湾智慧港动态数字孪生场景...",
          date: "2023-10-20",
          img: require("@/assets/images/digital/news/53.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/319.html"
        },
        {
          title: "大数据时代数字孪生技术在城市规划中的应用分析",
          desc:
            "大数据技术系统软件自身难以产生一个极大的产业，大数据一定要和某一相关产业结合起来或是融合起来，才可以造成极大的经济收益。 能与大数据结合而产生极大经济收益的一个行业便是城市。城市并不是某一个或两个产业，而是众多产业的聚合体，另外有政府部门、住户、消费者、企业和工业生产等各种繁杂与复合型角色，城市...",
          date: "2023-10-20",
          img: require("@/assets/images/digital/news/54.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/288.html"
        },
        {
          title: "在新基建时代以“数字孪生技术”，助力智慧交通领域的发展与建设",
          desc:
            "数字孪生强调虚拟环境与真实数据的互联互通，在数字化的时代，万物都可以用数据的形式来描述，并按照固有的规律被参数化、模型化。在智慧交通应用中，数字孪生以数据为基础，模型为核心，把数据和模型注入到三维重建的城市交通网的内部，进行宏观、中观和微观的仿真模拟，构建数字孪生的交通引擎，可以应用于城市静态的...",
          date: "2023-11-10",
          img: require("@/assets/images/digital/news/55.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/465.html"
        },
        {
          title:
            "跟紧新基建浪潮的脚步，全面建设数字孪生下的智慧路灯综合管控平台解决方案",
          desc:
            "智慧灯杆管理将基于ZTMAP实现的GIS+BIM三维融化渲染平台、大数据引擎，结合数字孪生、物联网技术、云计算等服务平台，针对路灯智能管理对管控范围内所有路灯集中控制、实时数据监测、异常智能分析及设备老化故障报警等，以三维可视化交互界面在一张大屏上展示数据，同时把路灯管网和其他设施配置信息化管理...",
          date: "2023-11-10",
          img: require("@/assets/images/digital/news/56.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/461.html"
        },
        {
          title: "强大的3DGIS地理信息技术发展，成为土地规划管理建设的最新热点",
          desc:
            "以土地综合治理地理基础信息平台为依托，运用互联网、云计算、大数据、人工智能等技术，利用数字孪生技术、GPS设备与ZTMAP 3DGIS平台，把自然资源业务数据和视频采集网络进行深度融合在“一张图”“一个平台”上，在土地综合规划这一方面更实时、精准、可视、直观的实现全覆盖，使建设用地跟踪监管更加规...",
          date: "2023-11-10",
          img: require("@/assets/images/digital/news/57.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/455.html"
        },
        {
          title: "众所周“智”，未来将以数字孪生描绘新智慧电网三维可视化蓝图",
          desc:
            "电网系统的建设环境及内部结构往往是复杂多样的，运维模式主要是依靠安装传感器和人力巡检，很难对全站所有的位置进行监测，而且人工运维成本高，变电站作为电网的一个核心环节，数字孪生技术下打造的智慧电力的出现将改变这传统的运维模式，让正处于高度安全风险之中的电力建设方面发生新的转变，实现了变电站智能化、...",
          date: "2023-11-10",
          img: require("@/assets/images/digital/news/58.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/462.html"
        },
        {
          title:
            "得“田”独厚，数字孪生技术让农业管理领域智慧起来，打造线上线下一体化发展",
          desc:
            "2021年正值“十四五”规划开局的重要一年，在“十四五”规划中提到了重要纲要：“加快数字化发展 建设数字中国”、“坚持农业农村优先发展 全面推进乡村振兴”。我国作为一个农业大国，将以什么样的形式发展下去，是我们现在要解决的关键问题。在数字化时代的发展下，以数字化产业为发展主线，数据为关键的生产要...",
          date: "2023-11-10",
          img: require("@/assets/images/digital/news/59.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/463.html"
        },
        {
          title: "以数字孪生技术赋能智慧校园建设，迎接智能未来",
          desc:
            "2021年是“十四五”规划的重要开局之年，而教育部也将加快推进教育专网建设，普及数字校园建设及应用，打造校园管理一张网，完善智慧校园的基础设施；结合智慧校园三维可视化管控平台，部署多种传感器和物联网应用，如搭载智能门禁和安防监控设备，覆盖在校园大门等各大重要场所，对校园进行全方位把控，实现校园管...",
          date: "2023-11-10",
          img: require("@/assets/images/digital/news/60.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/464.html"
        },
        {
          title: "在“ 新基建 ”的概念下，如何搭建智能可视化热网管控平台？",
          desc:
            "智能供暖是针对“源-网-荷-储”系统全过程，以二三维GIS地理信息系统为基础平台，以三维可视化为融合渲染平台，以大数据分析决策为核心平台，与热网指挥调度系统、全网自控专家系统、热网视频监控系统、热网收费管理系统、热网客户服务系统、热网设备管理系统、热网智能巡检系统、热网运行分析系统、热网能耗分析系统、智能二网平衡系统等紧密结合，打造信息透明化、方案集成化、数据可视化、管理智能化的综合性服务云平台——智能热网管控一体化平台...",
          date: "2023-11-24",
          img: require("@/assets/images/digital/news/61.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/452.html"
        },
        {
          title: "推进传统创造业数字化转型，助力打造新型智慧化工园区",
          desc:
            "面对我国化工园区，上海臻图信息将整体规划设计立足四川某区建设的经济开发园区实际情况为支撑底座，为园区管理者和入驻企业建设一套完善封闭式园区管理系统，依托云计算、大数据、物联网、地理信息系统、5G、GIS+3D 地理信息系统等信息技术，结合适度感知、智能识别园区运营管控数据，通过在线分析、整合和处理的基础上实现多维度、可视化的运营管理数据动态监测...",
          date: "2023-11-24",
          img: require("@/assets/images/digital/news/62.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/454.html"
        },
        {
          title: "Gis地理信息技术对物业管理的重要性你了解吗？",
          desc:
            "物业管理是个朝阳性的行业，随着数字化时代的兴起，各行各业的生存与发展都离不不开信息化的建设，物业公司也早已做好了智慧物业规划，已经应用到的很多高档小区、居民住宅、商业办公、商场服务管理、工业物业等领域，梳理了近几年物业管理背景，针对目前物业管理中信息管理混乱、维护服务不到位、周边招商发展规划等问题...",
          date: "2023-11-24",
          img: require("@/assets/images/digital/news/63.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/456.html"
        },
        {
          title: "搭上数字化基建的“快车”推进监所向智慧化管理转型",
          desc:
            "智慧监所三维可视化管控平台是依据监所的监控、门禁、对讲、巡更、报警、定位、会见等子系统实际情况，依托最新物联网技术，结合臻图ZTMAP 3DGIS平台、视频监控设备、云服务器等智能化分析等技术，搭建数字孪生体系的三维可视化管控平台。 通过物联网信息化等手段的融合高效利用,实现立体化全方位感知管理,有效提升监所管理的现代化水平，监所安全防范与应急指挥平台，环节严密把控、信息融合、规范执法、可视调度，从而为预警防范和应急处理提供全面的信息支撑和灵活的技术手段。体现一个入口、一致指挥、一同联动、自由扩展、升级便捷等特点...",
          date: "2023-11-24",
          img: require("@/assets/images/digital/news/64.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/453.html"
        },
        {
          title: "基于臻图ZTMAP GIS核心技术，建设国内新型智慧城市解决方案",
          desc:
            "深入分析智慧城市管理对象，管理手段和管理流程，以物联网网格化管理为手段，基于组件式技术进行开发，对海量数据的分析，开展城市管理关键技术应用研究，充分整合城市管理与服务资源，构建基于臻图ZTMAP 2.5D GIS城市地图的管理可视化系统，由单向到双向、由二维到三维、由静态到动态的转化，为城市的智慧空间治理提供时空大数据和空间分析技术支撑，实现城市管理“事前及时发现、事中高效处置、事后科学评价”，提升城市管理能力和服务水平，改善人居生态环境...",
          date: "2023-11-24",
          img: require("@/assets/images/digital/news/65.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/451.html"
        },
        {
          title: "基于臻图ZTMAP技术，实现数字孪生下的海洋数据动态可视化平台",
          desc:
            "地球表面的70%都被海洋所包围，多年来我国一直致力于海洋事业发展，随着近期台风的影响，人类对海洋资源的不断索取中发现，海洋环境、大气气象等问题日益暴露。在维护海洋健康、加强海洋管理、保障国家开发资源安全等任务也越发艰巨，在专业的科学智能化领域的不断深入探索，数字孪生在应用领域将对海洋环境数据可视化结果的真实感、可视化过程中的实时交互技术要求不断推进。 一体化建模： 就目前而言，海洋环境数据监测可视化已经广泛应用到海洋实时预告领域中。基于臻图ZTMAP技术，结合大数据、云服务等三位渲染平台，为海洋环境管理、海洋环境监测信息化搭建多维感知、高效协同的智慧化平台...",
          date: "2023-11-24",
          img: require("@/assets/images/digital/news/66.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/450.html"
        },
        {
          title:
            "关于数字孪生技术赋能协同一体化智慧公交建设，你想知道的解决方案都在这里",
          desc:
            "公交车是城市文明的流动窗口，反映着一座城市的文明程度和发展进程，而智慧公交是智慧城市必不可少的组成部分之一，随着信息技术的应用于发展，公交行业也将抓住数字化转型战略机遇，及时响应市场的需求，打造资源共享、创新驱动的智慧公交。 整体智慧公交数字孪生三维可视化平台，以客流车流调动信息为基础，考虑到了...",
          date: "2024-04-18",
          img: require("@/assets/images/digital/news/67.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/467.html"
        },
        {
          title:
            "数字孪生技术下的智慧医院再添新功能，室内地图导航让你“医”路畅通",
          desc:
            "如今，我国已经步入了“十四五”建设中，随着互联网业务的细分，医院和医疗的大数据建设也在逐渐向智慧化方向完善。但是医院建筑作为公共建筑最复杂结构之一，它拥有规模大、功能复杂等特点。面向医护人员、患者就诊、医院管理、追踪调查、监护查询等一系列基础医疗服务问题开始引起医院和人们的重视...",
          date: "2024-04-18",
          img: require("@/assets/images/digital/news/68.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/468.html"
        },
        {
          title:
            "结合GIS+BIM数字孪生应用，将构建智慧综合管廊工程三维渲染新高地",
          desc:
            "城市里，鳞次栉比的摩天大楼是看得见的繁华，纵横交错的地下管线是看不见的根基。逐渐对“蜘蛛网”“拉链式”的主干街道进行改观，改善城市的地景面貌，智慧地下综合管廊的搭建，同时又能打破传统的二维设计图纸的局限，集管理协调机制、管线信息共享打造一体化的安全可视化运行管理...",
          date: "2024-04-18",
          img: require("@/assets/images/digital/news/69.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/469.html"
        },
        {
          title: "以“实景+科幻三维建模渲染”，助力“实景三维中国建设”",
          desc:
            "数字孪生三维可视化平台是上海臻图自主研发的一套面向互联网应用的建议交互式可视化地图服务接口和工具，基于WEBGL，搭建的轻量化、高精度增强渲染平台，摆脱了对服务器的依赖限制，实现高并发深度空间访问，完美的兼容了B/S架构，从而大大降低智慧城市GIS+BIM+VR相关三维应用开发的技术难度和成本...",
          date: "2024-04-18",
          img: require("@/assets/images/digital/news/70.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/466.html"
        },
        {
          title: "数字孪生:迈向未来，智慧城市大脑运营方案及整体建设解决方针",
          desc:
            "基于云端的智慧城市大脑平台，为城市数字孪生应用场景提供了一个开发的中枢神经系统，同时平台依托ZTMAP3DGIS系统、人工智能、集成指挥中心平台、大数据资源管理，通过数字孪生为底座，建设实景三维展现，承载起城市信息模型和交互共享查询，允许每一个参与方都可以实时追踪和共享每个阶段的信息...",
          date: "2024-04-18",
          img: require("@/assets/images/digital/news/71.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/473.html"
        },
        {
          title:
            "上海臻图信息将以数字孪生技术开发，赋能智慧港口照明自动化系统新解决方案",
          desc:
            "港口是位于海、江、河、湖、水库沿岸，具有水陆联运设备以及条件以供船舶安全进出和停泊的运输枢纽。一直以来，港口码头作为进出口贸易的最大运输枢纽平台，国内港口的作业生产均采用是24小时全天候作业模式，那么为了保障港口安全有序的正常作业，规模庞大的照明系统就显得尤为重要，而照明所消耗的电力巨大，面对资...",
          date: "2024-04-18",
          img: require("@/assets/images/digital/news/72.png"),
          url: "http://www.ztmapinfo.com/blog/index.php/article/471.html"
        }
      ].reverse()
    };
  },
  methods: {
    handlehref(url) {
      window.location.href = url;
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../assets/images/digital/bg.jpg");
}

.team .title,
.we .title,
.process .title {
  color: #3a3a3a;
  font-size: 38px;
  text-align: center;
}
.digital {
  .team {
    padding: 100px 0;

    .list {
      display: flex;
      justify-content: space-between;
      margin-top: 40px;

      > div {
        width: 270px;
        height: 550px;
        box-sizing: border-box;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
        border: 1px solid #dddddd;
        border-radius: 10px;
        box-sizing: border-box;
        overflow: hidden;

        .title {
          margin: 215px 0 10px 0;
          color: #4b4b4b;
          font-size: 20px;
        }

        .p {
          font-size: 16px;
          color: rgba(124, 124, 124, 1);
          line-height: 30px;
          padding: 0 10px;
        }

        p {
          text-indent: 30px;
          margin-top: 0;
        }

        .button {
          width: 140px;
          height: 35px;
          background: url("../assets/images/digital/5333.png") no-repeat;
          background-size: 100% 100%;
          margin: 38px auto 0;
          cursor: pointer;
        }

        &:last-child {
          margin-right: 0;
        }

        &:nth-child(1) {
          background: url("../assets/images/digital/1.png") no-repeat;
          background-size: 100% 200px;
        }

        &:nth-child(2) {
          background: url("../assets/images/digital/2.png") no-repeat;
          background-size: 100% 200px;
        }

        &:nth-child(3) {
          background: url("../assets/images/digital/3.png") no-repeat;
          background-size: 100% 200px;
        }

        &:nth-child(4) {
          background: url("../assets/images/digital/4.png") no-repeat;
          background-size: 100% 200px;
        }
      }
    }
  }

  .application {
    background: #f8f8f8;
    padding: 40px 0;

    .module {
      > .title {
        color: #3a3a3a;
        font-size: 38px;
        text-align: center;
      }

      .list {
        margin-top: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        & > div:nth-child(1) {
          background: url("../assets/images/digital/application/1.gif")
            no-repeat;
          background-size: 100% 80%;
        }

        & > div:nth-child(2) {
          background: url("../assets/images/digital/application/2.gif")
            no-repeat;
          background-size: 100% 80%;
        }

        & > div:nth-child(3) {
          background: url("../assets/images/digital/application/3.gif")
            no-repeat;
          background-size: 100% 80%;
        }

        & > div:nth-child(4) {
          background: url("../assets/images/digital/application/6.gif")
            no-repeat;
          background-size: 100% 80%;
        }

        & > div:nth-child(5) {
          background: url("../assets/images/digital/application/5.gif")
            no-repeat;
          background-size: 100% 80%;
        }

        & > div:nth-child(6) {
          background: url("../assets/images/digital/application/4.gif")
            no-repeat;
          background-size: 100% 80%;
        }

        > div {
          width: 30%;
          height: 260px;
          margin-bottom: 40px;
          box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
          position: relative;
          perspective: 1000;

          > div {
            transition: all 0.2s linear;
            position: absolute;
            height: 100%;
            width: 100%;
            backface-visibility: hidden;
            text-align: center;
          }

          &:hover {
            .title {
              transform: rotateY(-180deg);
            }

            .content {
              transform: rotateY(-360deg);
            }
          }

          .title {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 20%;
            bottom: 0;
            font-size: 20px;
            color: #000;

            //   background: rgba(0, 0, 0, 0.5);
            > img {
              margin: 116px auto 10px auto;
            }
          }

          .content {
            background: rgba(2, 118, 247, 0.9);
            transform: rotateY(-180deg);
            padding: 40px 25px;
            color: #fff;
            box-sizing: border-box;

            > span {
              font-size: 20px;
            }

            > img {
              margin: 58px auto 10px auto;
            }

            > p {
              margin: 10px 0 20px 0;
              color: rgba(255, 255, 255, 0.6);
              line-height: 30px;
              text-align: center;
            }

            .btn {
              padding-bottom: 5px;
              border-bottom: 1px solid #fff;
              display: inline-block;
              margin: 0 auto;
              cursor: pointer;
            }
          }
        }
      }
    }

    .more {
      margin-top: 50px;
    }
  }

  .digital_list {
    > .title {
      color: #3a3a3a;
      font-size: 38px;
      text-align: center;
      margin-top: 40px;
    }

    .module {
      padding: 40px 0;
      display: flex;
      flex-wrap: wrap;
      > div {
        width: 584px;
        height: 422px;
        background: #ccc;
        display: inline-block;
        margin-right: 21px;
        margin-top: 30px;
        padding: 0 20px;
        box-sizing: border-box;
        box-shadow: 0px 0px 60px 10px rgba(13, 37, 62, 0.1);
        color: #4b4b4b;
        background: no-repeat top center / 100% 80%;
        vertical-align: top;
        cursor: pointer;
        @List: 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12;

        .ml-loop(@list, @i: 1, @val: extract(@list, @i))
          when
          (length(@list)>=@i) {
          &:nth-of-type(@{val}) {
            background-image: url("../assets/images/digital/list/@{val}.gif");
          }

          .ml-loop(@list, (@i+1));
        }

        .ml-loop(@List);

        .title {
          font-size: 20px;
          margin-top: 370px;
          text-align: center;
        }

        &:nth-of-type(2n) {
          margin-right: 0;
        }

        &:nth-of-type(1),
        &:nth-of-type(2) {
          margin-top: 0;
        }
      }
    }
  }

  .new_list {
    > .title {
      color: #3a3a3a;
      font-size: 38px;
      text-align: center;
      margin-top: 40px;

      div {
        display: inline-block;
        padding: 0 80px;
        border-left: 5px solid #395ca9;
        border-right: 5px solid #395ca9;
      }
    }

    .module {
      padding: 40px 0;

      .item {
        width: 100%;
        height: 220px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-bottom: 30px;
        padding: 0 20px 20px;
        box-sizing: border-box;
        cursor: pointer;

        .title-wrapper {
          width: 100%;
          height: 50px;
          line-height: 50px;
          color: #338ecf;
          font-size: 20px;
        }

        .content-wrapper {
          display: flex;
          height: calc(100% - 50px);

          .img-wrapper {
            margin-right: 20px;

            > img {
              width: 246px;
              height: 150px;
            }
          }

          .text-wrapper {
            flex-grow: 1;
            -webkit-box-flex: 1;
            > div:first-child {
              font-size:20px;
              text-indent: 30px;
              line-height: 25px;
              margin-top: 10px;
              min-width: 0; // 防止其他元素被挤压
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3; // 限制的文字行数
              color: #666;
            }

            .date-wrapper {
              margin-top: 35px;
              display: flex;
              justify-content: space-between;
              font-size: 20px;
              > div:first-child {
                display: flex;
                align-items: center;
              }

              .icon {
                width: 25px;
                height: 25px;
                margin-top: 2px;
                background: url("../assets/images/digital/icon.png") no-repeat;
                background-size: 100% 100%;
              }
            }
          }
        }
      }
    }
  }
}
.mobile-digital {
  display: none;
  width: 100%;
  flex-direction: column;
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../assets/images/digital/bg.jpg");
    background-position: 50%;
    background-size: cover;
    height: 28rem;
  }
  .main {
    width: 100%;
    font-family: 'Normal';
    .part1 {
      width: 100%;
      color: #3C80E8;
      box-sizing: border-box;
      padding: 2rem;
      .part1-title {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        color: #333333;
      }
      .part1-content{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .item {
          width: 16.5rem;
          height: 29rem;
          border-radius: 6px;
          box-sizing: border-box;
          border: 1px solid #EBEBEB;
          margin-top: 2rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          >img {
            width: 16.5rem;
            height: 12rem;
            border-radius: 5px 5px 0px 0px;
          }
          .title1 {
            font-size: 1.4rem;
            height: 4rem;
            line-height: 4rem;
            font-weight: bold;
            text-align: center;
            color: #333333;
          }
          .p {
            width: 100%;
            box-sizing: border-box;
            padding: 0 1rem;
            p {
              text-indent: 2em;
              font-size: 1rem;
              font-weight: 350;
              line-height: 1.5rem;
              color: #333333;
              margin: 0;
            }
          }
          .button {
            width: 7rem;
            height: 1.75rem;
            background: url("../assets/images/digital/5333.png") no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
            margin-top: 1rem;
          }
        }
      }
    }
    .part2 {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem 1.5rem;
      background: #F8F8F8;
      .part2-title {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        color: #333333;
      }
      .part2-content {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        >div {
          width: 16.5rem;
          height: 10rem;
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 3rem;
          color: #fff;
          margin-top: 1.5rem;
          >div {
            background: rgba(0, 0, 0, 0.2);
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        & > div:nth-child(1) {
          background-image: url('../assets/images/digital/application/1.gif');
          background-repeat: no-repeat;
          background-size: cover;
        }
        & > div:nth-child(2) {
          background-image: url('../assets/images/digital/application/2.gif');
          background-repeat: no-repeat;
          background-size: cover;
        }
        & > div:nth-child(3) {
          background-image: url('../assets/images/digital/application/3.gif');
          background-repeat: no-repeat;
          background-size: cover;
        }
        & > div:nth-child(4) {
          background-image: url('../assets/images/digital/application/6.gif');
          background-repeat: no-repeat;
          background-size: cover;
        }
        & > div:nth-child(5) {
          background-image: url('../assets/images/digital/application/5.gif');
          background-repeat: no-repeat;
          background-size: cover;
        }
        & > div:nth-child(6) {
          background-image: url('../assets/images/digital/application/4.gif');
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }
    .part3 {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem 1.5rem;
      .part3-title {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        color: #333333;
      }
      .list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        >div {
          width: 16.5rem;
          height: 10rem;
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 2rem;
          color: #fff;
          margin-top: 1.5rem;
          cursor: pointer;
          .title {
            background: rgba(0, 0, 0, 0.2);
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
          }
          @List: 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12;
          .ml-loop(@list,@i:1,@val:extract(@list,@i)) when (length(@list)>=@i) {
            &:nth-of-type(@{val}) {
              background-image: url("../assets/images/digital/list/@{val}.gif");
              background-repeat: no-repeat;
              background-size: cover;
            }
            .ml-loop(@list, (@i+1));
          }
          .ml-loop(@List);
        }
      }
      .more{
        margin-top: 2rem;
        margin-bottom: 2rem;
        width: 11.5rem;
        height: 3.5rem;
        border-radius: 1.75rem;
        background: #3C80E8;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        border: none;
        p {
          font-size: 1.2rem;
          font-weight: 350;
          line-height: 2rem;
        }
        >div {
          display: flex;
          flex-direction: column;
          height: 1.6rem;
          margin-left: 1rem;
          >i {
            font-size: 1rem;
            &:nth-of-type(2) {
              margin-top: -0.6rem;
            } 
          }
        }
      }
    }
    .part4 {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem 1.5rem;
      background: #F8F8F8;
      .part4-title {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        color: #333333;
      }
      .list {
        width: 100%;
        font-family: 'Normal';
        .item {
          width: 100%;
          height: 12rem;
          border-bottom: 1px solid #EBEBEB;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .image {
            width: 14rem;
            height: 10rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .item-content {
            width: 19rem;
            height: 10rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            >p {
              width: 100%;
              font-size: 1.4rem;
              font-weight: bold;
              line-height: 2rem;
              color: #333333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin: 0;
            }
            .item-span {
              width: 100%;
              height: 4.5rem;
              margin-top: 1rem;
              font-size: 1rem;
              font-weight: normal;
              line-height: 1.5rem;
              color: #333333;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
            }
            .item-bottom {
              width: 100%;
              margin-top: 0.5rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              >span {
                font-size: 1rem;
                font-weight: normal;
                line-height: 2rem;
              }
              >div {
                display: flex;
                align-items: center;
                color: #3C80E8;
                height: 2rem;
                cursor: pointer;
                >p {
                  
                }
                >i {
                  font-size: 1rem;
                  height: 1rem;
                  margin-left: 1rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .digital {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-digital { 
    display: flex !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/digital.vue